function numeralFemaleEnding(condition) {
    const val = condition % 10;

    return val === 3 && condition !== 13
        ? condition + "-ью"
        : condition + "-ую";
}

function numeralMaleEnding(condition) {
    const val = condition % 10;

    if ((condition >= 10 && condition <= 20)
        || (val === 0 && condition !== 0 && condition % 100 !== 40)
        || (val === 1 || val === 4 || val === 5 || val === 9)
    ) {
        return condition + "-ый";
    }

    return val === 3 ? condition + "-ий" : condition + "-ой";
}

function numeralNeuterEnding(condition) {
    const val = condition % 10;
    return val === 3 && condition !== 13 ? condition + "-ье" : condition + "-ое";
}

function plural(count, parameters) {
    const m10 = count % 10;
    const m100 = count % 100;

    if (m10 === 1 && m100 !== 11) {
        return parameters[0];
    }

    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
        return parameters[1];
    }

    return parameters[2];
}

function signed(condition) {
    if (condition === 0) {
        return '0';
    }

    const num = Number.parseFloat(condition.toFixed(2));

    if (condition > 0) {
        return '+' + num.toString();
    }

    return num.toString();
}

function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}

const sl_b1 = (match, outcome) => 'Результат';
const sl_c1 = (match, outcome) => 'Фора';
const sl_d1 = (match, outcome) => 'Тотал';
const sl_e1 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])}`;
const sl_f1 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко`;
const sl_g1 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])}`;
const sl_h1 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])}`;
const sl_i1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const sl_j1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const sl_k1 = (match, outcome) => 'Победа';
const sl_l1 = (match, outcome) => 'Точный тотал';
const sl_m1 = (match, outcome) => `${match.homeTeam} Победа с разницей`;
const sl_n1 = (match, outcome) => `${match.awayTeam} Победа с разницей`;
const sl_o1 = (match, outcome) => 'Разница очков';
const sl_p1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const sl_q1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const sl_r1 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])}`;
const sl_s1 = (match, outcome) => 'Первый в матче';
const sl_t1 = (match, outcome) => 'Победа с разницей';
const sl_u1 = (match, outcome) => 'Сколько команд забьет?';
const sl_v1 = (match, outcome) => 'Точный счет';
const sl_w1 = (match, outcome) => `Победа и тотал ${outcome.condition}`;
const sl_x1 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])}`;
const sl_y1 = (match, outcome) => 'Чет/Нечет';
const sl_z1 = (match, outcome) => `${match.homeTeam} победит с разницей`;
const sl_a2 = (match, outcome) => `${match.awayTeam} победит с разницей`;
const sl_b2 = (match, outcome) => `${match.homeTeam} Точный тотал`;
const sl_c2 = (match, outcome) => `${match.awayTeam} Точный тотал`;
const sl_d2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['убийство', 'убийства', 'убийств'])}`;
const sl_e2 = (match, outcome) => 'First Blood';
const sl_f2 = (match, outcome) => `Забьет ли ${match.homeTeam}?`;
const sl_g2 = (match, outcome) => `Забьет ли ${match.awayTeam}?`;
const sl_h2 = (match, outcome) => 'Сколько команд забьёт';
const sl_i2 = (match, outcome) => `Сколько голов забьет ${match.homeTeam}?`;
const sl_j2 = (match, outcome) => `Сколько голов забьет ${match.awayTeam}?`;
const sl_k2 = (match, outcome) => 'Компенсированное время';
const sl_l2 = (match, outcome) => `Европейская фора ${europeanHandicapCondition(outcome.condition)}`;
const sl_m2 = (match, outcome) => `Кто забьет ${numeralMaleEnding(outcome.condition)} гол?`;
const sl_n2 = (match, outcome) => `Остаток (текущий счет ${outcome.condition}:${outcome.conditionTwo})`;
const sl_o2 = (match, outcome) => 'Двойной исход';
const sl_p2 = (match, outcome) => 'С каждого флажка';
const sl_q2 = (match, outcome) => 'Результат матча';
const sl_r2 = (match, outcome) => 'За симуляцию';
const sl_s2 = (match, outcome) => 'За снятую футболку';
const sl_t2 = (match, outcome) => `Тотал забитых пенальти: ${match.awayTeam}`;
const sl_u2 = (match, outcome) => `Тотал забитых пенальти: ${match.homeTeam}`;
const sl_v2 = (match, outcome) => 'Тотал забитых пенальти';
const sl_w2 = (match, outcome) => 'Тотал незабитых пенальти';
const sl_x2 = (match, outcome) => `Победа ${match.homeTeam} с разницей`;
const sl_y2 = (match, outcome) => `Победа ${match.awayTeam} с разницей`;
const sl_z2 = (match, outcome) => 'Кто первым(ой) забьет шар?';
const sl_a3 = (match, outcome) => 'Какой цветной шар будет забит первым?';
const sl_b3 = (match, outcome) => 'Чет/Нечет тотала';
const sl_c3 = (match, outcome) => `Будет ли в ${outcome.condition} гейме?`;
const sl_d3 = (match, outcome) => 'Тотал брейков';
const sl_e3 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])}`;
const sl_f3 = (match, outcome) => 'Будет ли тай-брейк?';
const sl_g3 = (match, outcome) => 'Кто победит в тай-брейке?';
const sl_h3 = (match, outcome) => 'Точный тотал тай-брейка';
const sl_i3 = (match, outcome) => 'Точный счет тай-брейка';
const sl_j3 = (match, outcome) => 'Тотал тай-брейка';
const sl_k3 = (match, outcome) => `Тотал брейков: ${match.homeTeam}`;
const sl_l3 = (match, outcome) => `Тотал брейков: ${match.awayTeam}`;
const sl_m3 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])}?`;
const sl_n3 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])}?`;
const sl_o3 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])}?`;
const sl_p3 = (match, outcome) => 'Результат по брейкам';
const sl_q3 = (match, outcome) => 'Фора по брейкам';
const sl_r3 = (match, outcome) => `Победа и тотал${outcome.condition}`;

const bo_b1 = (match, outcome) => 'Фора';
const bo_c1 = (match, outcome) => 'Тотал матча';
const bo_d1 = (match, outcome) => `Тотал: ${match.homeTeam}`;
const bo_e1 = (match, outcome) => `Тотал: ${match.awayTeam}`;
const bo_f1 = (match, outcome) => 'Чет/Нечет тотала матча';
const bo_g1 = (match, outcome) => `${match.homeTeam} - ${match.awayTeam}`;
const bo_h1 = (match, outcome) => `${outcome.teamOne} - ${outcome.teamTwo}`;
const bo_i1 = (match, outcome) => `${outcome.teamOne}`;
const bo_j1 = (match, outcome) => 'Фора в первом сете';
const bo_k1 = (match, outcome) => 'Фора во втором сете';
const bo_l1 = (match, outcome) => 'Фора в третьем сете';
const bo_m1 = (match, outcome) => 'Тотал первого сета';
const bo_n1 = (match, outcome) => 'Тотал второго сета';
const bo_o1 = (match, outcome) => 'Тотал третьего сета';
const bo_p1 = (match, outcome) => 'Тотал сетов в матче';
const bo_q1 = (match, outcome) => 'Счет матча';
const bo_r1 = (match, outcome) => 'Результат первого сета';
const bo_s1 = (match, outcome) => 'Результат второго сета';
const bo_t1 = (match, outcome) => 'Результат третьего сета';
const bo_u1 = (match, outcome) => `Тотал: ${match.homeTeam} в первом сете`;
const bo_v1 = (match, outcome) => `Тотал: ${match.homeTeam} во втором сете`;
const bo_w1 = (match, outcome) => `Тотал: ${match.homeTeam} в третьем сете`;
const bo_x1 = (match, outcome) => `Тотал: ${match.awayTeam} в первом сете`;
const bo_y1 = (match, outcome) => `Тотал: ${match.awayTeam} во втором сете`;
const bo_z1 = (match, outcome) => `Тотал: ${match.awayTeam} в третьем сете`;
const bo_a2 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в первом сете`;
const bo_b2 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во втором сете`;
const bo_c2 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в третьем сете`;
const bo_d2 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в первом сете`;
const bo_e2 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во втором сете`;
const bo_f2 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в третьем сете`;
const bo_g2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 1ом сете`;
const bo_h2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во 2ом сете`;
const bo_i2 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 3ем сете`;
const bo_j2 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в первом сете`;
const bo_k2 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко во втором сете`;
const bo_l2 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в третьем сете`;
const bo_m2 = (match, outcome) => 'Победа в минисете до 10 очков первого сета';
const bo_n2 = (match, outcome) => 'Победа в минисете до 10 очков второго сета';
const bo_o2 = (match, outcome) => 'Победа в минисете до 10 очков третьего сета';
const bo_p2 = (match, outcome) => 'Фора в минисете до 10 очков первого сета';
const bo_q2 = (match, outcome) => 'Фора в минисете до 10 очков второго сета';
const bo_r2 = (match, outcome) => 'Фора в минисете до 10 очков третьего сета';
const bo_s2 = (match, outcome) => 'Тотал в минисете до 10 очков первого сета';
const bo_t2 = (match, outcome) => 'Тотал в минисете до 10 очков второго сета';
const bo_u2 = (match, outcome) => 'Тотал в минисете до 10 очков третьего сета';
const bo_v2 = (match, outcome) => 'Победа в минисете до 15 очков первого сета';
const bo_w2 = (match, outcome) => 'Победа в минисете до 15 очков второго сета';
const bo_x2 = (match, outcome) => 'Победа в минисете до 15 очков третьего сета';
const bo_y2 = (match, outcome) => 'Фора в минисете до 15 очков первого сета';
const bo_z2 = (match, outcome) => 'Фора в минисете до 15 очков второго сета';
const bo_a3 = (match, outcome) => 'Фора в минисете до 15 очков третьего сета';
const bo_b3 = (match, outcome) => 'Тотал в минисете до 15 очков первого сета';
const bo_c3 = (match, outcome) => 'Тотал в минисете до 15 очков второго сета';
const bo_d3 = (match, outcome) => 'Тотал в минисете до 15 очков третьего сета';
const bo_e3 = (match, outcome) => `Тотал: ${match.homeTeam} в первом тайме`;
const bo_f3 = (match, outcome) => 'Фора в первом тайме';
const bo_g3 = (match, outcome) => 'Результат первого тайма';
const bo_h3 = (match, outcome) => `Тотал: ${match.awayTeam} в первом тайме`;
const bo_i3 = (match, outcome) => `Кто забьет ${numeralMaleEnding(outcome.condition)} гол?`;
const bo_j3 = (match, outcome) => 'Двойной исход';
const bo_k3 = (match, outcome) => 'Тотал первого тайма';
const bo_l3 = (match, outcome) => `Победа и тотал матча ${outcome.condition}`;
const bo_m3 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_n3 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_o3 = (match, outcome) => 'Точный тотал матча';
const bo_p3 = (match, outcome) => 'Сколько команд забьёт';
const bo_q3 = (match, outcome) => 'Точный счет';
const bo_r3 = (match, outcome) => 'Азиатская фора';
const bo_s3 = (match, outcome) => 'Фора в первой четверти';
const bo_t3 = (match, outcome) => 'Фора во второй четверти';
const bo_u3 = (match, outcome) => 'Фора в третьей четверти';
const bo_v3 = (match, outcome) => 'Фора в четвертой четверти';
const bo_w3 = (match, outcome) => 'Тотал первой четверти';
const bo_x3 = (match, outcome) => 'Тотал второй четверти';
const bo_y3 = (match, outcome) => 'Тотал третьей четверти';
const bo_z3 = (match, outcome) => 'Тотал четвертой четверти';
const bo_a4 = (match, outcome) => 'Результат первой четверти';
const bo_b4 = (match, outcome) => 'Результат второй четверти';
const bo_c4 = (match, outcome) => 'Результат третьей четверти';
const bo_d4 = (match, outcome) => 'Результат четвертой четверти';
const bo_e4 = (match, outcome) => `Тотал: ${match.homeTeam} в первой четверти`;
const bo_f4 = (match, outcome) => `Тотал: ${match.homeTeam} во второй четверти`;
const bo_g4 = (match, outcome) => `Тотал: ${match.homeTeam} в третьей четверти`;
const bo_h4 = (match, outcome) => `Тотал: ${match.homeTeam} в четвертой четверти`;
const bo_i4 = (match, outcome) => `Тотал: ${match.awayTeam} в первой четверти`;
const bo_j4 = (match, outcome) => `Тотал: ${match.awayTeam} во второй четверти`;
const bo_k4 = (match, outcome) => `Тотал: ${match.awayTeam} в третьей четверти`;
const bo_l4 = (match, outcome) => `Тотал: ${match.awayTeam} в четвертой четверти`;
const bo_m4 = (match, outcome) => 'Тотал первой половины';
const bo_n4 = (match, outcome) => 'Результат во второй половине';
const bo_o4 = (match, outcome) => 'Тотал второй половины';
const bo_p4 = (match, outcome) => 'Фора в первой половине';
const bo_q4 = (match, outcome) => 'Фора во второй половине';
const bo_r4 = (match, outcome) => 'Результат в первой половине';
const bo_s4 = (match, outcome) => `Тотал: ${match.homeTeam} в первой половине`;
const bo_t4 = (match, outcome) => `Тотал: ${match.homeTeam} во второй половине`;
const bo_u4 = (match, outcome) => `Тотал: ${match.awayTeam} в первой половине`;
const bo_v4 = (match, outcome) => `Тотал: ${match.awayTeam} во второй половине`;
const bo_w4 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 1ой четверти`;
const bo_x4 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во 2ой четверти`;
const bo_y4 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 3ей четверти`;
const bo_z4 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 4ой четверти`;
const bo_a5 = (match, outcome) => 'Точный тотал первой четверти';
const bo_b5 = (match, outcome) => 'Точный тотал второй четверти';
const bo_c5 = (match, outcome) => 'Точный тотал третьей четверти';
const bo_d5 = (match, outcome) => 'Точный тотал четвертой четверти';
const bo_e5 = (match, outcome) => `${match.homeTeam} победит с разницей`;
const bo_f5 = (match, outcome) => `${match.awayTeam} победит с разницей`;
const bo_g5 = (match, outcome) => 'Проход';
const bo_h5 = (match, outcome) => `${match.homeTeam} выиграет все четверти`;
const bo_i5 = (match, outcome) => `${match.awayTeam} выиграет все четверти`;
const bo_j5 = (match, outcome) => `${match.homeTeam} выиграет обе половины`;
const bo_k5 = (match, outcome) => `${match.awayTeam} выиграет обе половины`;
const bo_l5 = (match, outcome) => 'Самая результативная половина';
const bo_m5 = (match, outcome) => 'Самая результативная четверть';
const bo_n5 = (match, outcome) => 'Тотал самой результативной четверти';
const bo_o5 = (match, outcome) => 'Тотал самой нерезультативной четверти';
const bo_p5 = (match, outcome) => `${match.homeTeam} выиграет первую четверть и матч`;
const bo_q5 = (match, outcome) => `${match.awayTeam} выиграет первую четверть и матч`;
const bo_r5 = (match, outcome) => `${match.homeTeam} выиграет первую половину и матч`;
const bo_s5 = (match, outcome) => `${match.awayTeam} выиграет первую половину и матч`;
const bo_t5 = (match, outcome) => 'Будет ли овертайм';
const bo_u5 = (match, outcome) => 'Победа с разницей';
const bo_v5 = (match, outcome) => 'Победа с разницей в первой четверти';
const bo_w5 = (match, outcome) => 'Победа с разницей во второй четверти';
const bo_x5 = (match, outcome) => 'Победа с разницей в третьей четверти';
const bo_y5 = (match, outcome) => 'Победа с разницей в четвертой четверти';
const bo_z5 = (match, outcome) => `Тотал: ${outcome.playerName} (${match.homeTeam})`;
const bo_a6 = (match, outcome) => `Тотал: ${outcome.playerName} (${match.awayTeam})`;
const bo_b6 = (match, outcome) => 'Тотал: 3-очковые броски';
const bo_c6 = (match, outcome) => 'Тотал: 2-очковые броски';
const bo_d6 = (match, outcome) => `Тотал: ${match.homeTeam} 3-очковые броски`;
const bo_e6 = (match, outcome) => `Тотал: ${match.awayTeam} 3-очковые броски`;
const bo_f6 = (match, outcome) => `Тотал: ${match.homeTeam} 2-очковые броски`;
const bo_g6 = (match, outcome) => `Тотал: ${match.awayTeam} 2-очковые броски`;
const bo_h6 = (match, outcome) => 'Фора 3-очковых бросков';
const bo_i6 = (match, outcome) => 'Фора 2-очковых бросков';
const bo_j6 = (match, outcome) => 'Результат по 3-очковым броскам';
const bo_k6 = (match, outcome) => 'Результат по 2-очковым броскам';
const bo_l6 = (match, outcome) => 'Самая НЕ результативная четверть';
const bo_m6 = (match, outcome) => 'Тотал передач в матче';
const bo_n6 = (match, outcome) => `Тотал передач ${match.homeTeam} в матче`;
const bo_o6 = (match, outcome) => `Тотал передач ${match.awayTeam} в матче`;
const bo_p6 = (match, outcome) => 'Фора по передачам в матче';
const bo_q6 = (match, outcome) => 'Победа по передачам в матче';
const bo_r6 = (match, outcome) => 'Первый 2-очковый бросок в матче';
const bo_s6 = (match, outcome) => 'Первый 3-очковый бросок в матче';
const bo_t6 = (match, outcome) => 'Первый штрафной бросок в матче';
const bo_u6 = (match, outcome) => 'Что будет раньше';
const bo_v6 = (match, outcome) => 'Наибольшее количество очков в четверти';
const bo_w6 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в матче`;
const bo_x6 = (match, outcome) => 'Тотал трипл-даблов в матче';
const bo_y6 = (match, outcome) => 'Тотал дабл-даблов в матче';
const bo_z6 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в первой четверти`;
const bo_a7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во второй четверти`;
const bo_b7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в третьей четверти`;
const bo_c7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в четвертой четверти`;
const bo_d7 = (match, outcome) => 'Разница очков в матче';
const bo_e7 = (match, outcome) => 'Разница очков в первой четверти';
const bo_f7 = (match, outcome) => 'Разница очков во второй четверти';
const bo_g7 = (match, outcome) => 'Разница очков в третьей четверти';
const bo_h7 = (match, outcome) => 'Разница очков в четвертой четверти';
const bo_i7 = (match, outcome) => 'Результат первой половины';
const bo_j7 = (match, outcome) => 'Результат второй половины';
const bo_k7 = (match, outcome) => 'Точный тотал первой половины';
const bo_l7 = (match, outcome) => 'Точный тотал второй половины';
const bo_m7 = (match, outcome) => 'Победа с разницей в первой половине';
const bo_n7 = (match, outcome) => 'Победа с разницей во второй половине';
const bo_o7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 1ой половине`;
const bo_p7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во 2ой половине`;
const bo_q7 = (match, outcome) => 'Тотал самой результативной половины';
const bo_r7 = (match, outcome) => 'Тотал самой НЕрезультативной половины';
const bo_s7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в первой половине`;
const bo_t7 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во второй половине`;
const bo_u7 = (match, outcome) => 'Тотал первого периода';
const bo_v7 = (match, outcome) => 'Тотал второго периода';
const bo_w7 = (match, outcome) => 'Тотал третьего периода';
const bo_x7 = (match, outcome) => 'Результат первого периода';
const bo_y7 = (match, outcome) => 'Результат второго периода';
const bo_z7 = (match, outcome) => 'Результат третьего периода';
const bo_a8 = (match, outcome) => 'Победа с учетом пенальти';
const bo_b8 = (match, outcome) => 'Победа с разницей 1';
const bo_c8 = (match, outcome) => 'Победа с разницей 2';
const bo_d8 = (match, outcome) => 'Сколько команд забьет в 1-м периоде?';
const bo_e8 = (match, outcome) => 'Сколько команд забьет в 2-м периоде?';
const bo_f8 = (match, outcome) => 'Сколько команд забьет в 3-м периоде?';
const bo_g8 = (match, outcome) => 'Период-Матч';
const bo_h8 = (match, outcome) => 'Тотал овертайма';
const bo_i8 = (match, outcome) => 'Результат оветайма';
const bo_j8 = (match, outcome) => 'Фора в овертайме';
const bo_k8 = (match, outcome) => 'Фора в первом периоде';
const bo_l8 = (match, outcome) => 'Фора во втором периоде';
const bo_m8 = (match, outcome) => 'Фора в третьем периоде';
const bo_n8 = (match, outcome) => 'Точный счет первого периода';
const bo_o8 = (match, outcome) => 'Точный счет второго периода';
const bo_p8 = (match, outcome) => 'Точный счет третьего периода';
const bo_q8 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 1ом сете`;
const bo_r8 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во 2ом сете`;
const bo_s8 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 3ем сете`;
const bo_t8 = (match, outcome) => 'Фора по партиям в матче';
const bo_u8 = (match, outcome) => 'Точный тотал первого сета';
const bo_v8 = (match, outcome) => 'Точный тотал второго сета';
const bo_w8 = (match, outcome) => 'Точный тотал третьего сета';
const bo_x8 = (match, outcome) => `${match.homeTeam} победит с разницей в первом сете`;
const bo_y8 = (match, outcome) => `${match.homeTeam} победит с разницей во втором сете`;
const bo_z8 = (match, outcome) => `${match.homeTeam} победит с разницей в третьем сете`;
const bo_a9 = (match, outcome) => `${match.awayTeam} победит с разницей в первом сете`;
const bo_b9 = (match, outcome) => `${match.awayTeam} победит с разницей во втором сете`;
const bo_c9 = (match, outcome) => `${match.awayTeam} победит с разницей в третьем сете`;
const bo_d9 = (match, outcome) => 'Чет/Нечет первого сета';
const bo_e9 = (match, outcome) => 'Чет/Нечет второго сета';
const bo_f9 = (match, outcome) => 'Чет/Нечет третьего сета';
const bo_g9 = (match, outcome) => `Победа и тотал первого сета ${outcome.condition}`;
const bo_h9 = (match, outcome) => `Победа и тотал второго сета ${outcome.condition}`;
const bo_i9 = (match, outcome) => `Победа и тотал третьего сета ${outcome.condition}`;
const bo_j9 = (match, outcome) => 'Победа с разницей в первом сете';
const bo_k9 = (match, outcome) => 'Победа с разницей во втором сете';
const bo_l9 = (match, outcome) => 'Победа с разницей в третьем сете';
const bo_m9 = (match, outcome) => 'Тотал на первом огневом рубеже';
const bo_n9 = (match, outcome) => 'Тотал на втором огневом рубеже';
const bo_o9 = (match, outcome) => 'Тотал на третьем огневом рубеже';
const bo_p9 = (match, outcome) => 'Тотал на четвертом огневом рубеже';
const bo_q9 = (match, outcome) => 'Тотал на пятом огневом рубеже';
const bo_r9 = (match, outcome) => 'Тотал на шестом огневом рубеже';
const bo_s9 = (match, outcome) => 'Тотал на седьмом огневом рубеже';
const bo_t9 = (match, outcome) => 'Тотал на восьмом огневом рубеже';
const bo_u9 = (match, outcome) => `Тотал: ${match.homeTeam} на первом огневом рубеже`;
const bo_v9 = (match, outcome) => `Тотал: ${match.homeTeam} на втором огневом рубеже`;
const bo_w9 = (match, outcome) => `Тотал: ${match.homeTeam} на тертьем огневом рубеже`;
const bo_x9 = (match, outcome) => `Тотал: ${match.homeTeam} на четвертом огневом рубеже`;
const bo_y9 = (match, outcome) => `Тотал: ${match.homeTeam} на пятом огневом рубеже`;
const bo_z9 = (match, outcome) => `Тотал: ${match.homeTeam} на шестом огневом рубеже`;
const bo_a10 = (match, outcome) => `Тотал: ${match.homeTeam} на седьмом огневом рубеже`;
const bo_b10 = (match, outcome) => `Тотал: ${match.homeTeam} на восьмом огневом рубеже`;
const bo_c10 = (match, outcome) => `Тотал: ${match.awayTeam} на первом огневом рубеже`;
const bo_d10 = (match, outcome) => `Тотал: ${match.awayTeam} на втором огневом рубеже`;
const bo_e10 = (match, outcome) => `Тотал: ${match.awayTeam} на тертьем огневом рубеже`;
const bo_f10 = (match, outcome) => `Тотал: ${match.awayTeam} на четвертом огневом рубеже`;
const bo_g10 = (match, outcome) => `Тотал: ${match.awayTeam} на пятом огневом рубеже`;
const bo_h10 = (match, outcome) => `Тотал: ${match.awayTeam} на шестом огневом рубеже`;
const bo_i10 = (match, outcome) => `Тотал: ${match.awayTeam} на седьмом огневом рубеже`;
const bo_j10 = (match, outcome) => `Тотал: ${match.awayTeam} на восьмом огневом рубеже`;
const bo_k10 = (match, outcome) => 'Фора на первом огневом рубеже';
const bo_l10 = (match, outcome) => 'Фора на втором огневом рубеже';
const bo_m10 = (match, outcome) => 'Фора на третьем огневом рубеже';
const bo_n10 = (match, outcome) => 'Фора на четвертом огневом рубеже';
const bo_o10 = (match, outcome) => 'Фора на пятом огневом рубеже';
const bo_p10 = (match, outcome) => 'Фора на шестом огневом рубеже';
const bo_q10 = (match, outcome) => 'Фора на седьмом огневом рубеже';
const bo_r10 = (match, outcome) => 'Фора на восьмом огневом рубеже';
const bo_s10 = (match, outcome) => 'Результат на первом огневом рубеже';
const bo_t10 = (match, outcome) => 'Результат на втором огневом рубеже';
const bo_u10 = (match, outcome) => 'Результат на третьем огневом рубеже';
const bo_v10 = (match, outcome) => 'Результат на четвертом огневом рубеже';
const bo_w10 = (match, outcome) => 'Результат на пятом огневом рубеже';
const bo_x10 = (match, outcome) => 'Результат на шестом огневом рубеже';
const bo_y10 = (match, outcome) => 'Результат на седьмом огневом рубеже';
const bo_z10 = (match, outcome) => 'Результат на восьмом огневом рубеже';
const bo_a11 = (match, outcome) => 'Точный тотал на первом огневом рубеже';
const bo_b11 = (match, outcome) => 'Точный тотал на втором огневом рубеже';
const bo_c11 = (match, outcome) => 'Точный тотал на третьем огневом рубеже';
const bo_d11 = (match, outcome) => 'Точный тотал на четвертом огневом рубеже';
const bo_e11 = (match, outcome) => 'Точный тотал на пятом огневом рубеже';
const bo_f11 = (match, outcome) => 'Точный тотал на шестом огневом рубеже';
const bo_g11 = (match, outcome) => 'Точный тотал на седьмом огневом рубеже';
const bo_h11 = (match, outcome) => 'Точный тотал на восьмом огневом рубеже';
const bo_i11 = (match, outcome) => 'Будет ли досрочная победа?';
const bo_j11 = (match, outcome) => 'Метод победы в бою';
const bo_k11 = (match, outcome) => 'Победа в бою';
const bo_l11 = (match, outcome) => 'Тотал';
const bo_m11 = (match, outcome) => `Кто выиграет ${outcome.condition} раунд?`;
const bo_n11 = (match, outcome) => 'FirstBlood';
const bo_o11 = (match, outcome) => `FirstBlood в ${outcome.condition} раунде`;
const bo_p11 = (match, outcome) => `Кто выиграет ${outcome.condition} карту?`;
const bo_q11 = (match, outcome) => `FirstBlood в ${outcome.condition} карте`;
const bo_r11 = (match, outcome) => `Кто первым наберет ${outcome.condition} убийств в 1ой карте`;
const bo_s11 = (match, outcome) => `Кто первым наберет ${outcome.condition} убийств во 2ой карте`;
const bo_t11 = (match, outcome) => `Кто первым наберет ${outcome.condition} убийств в 3ей карте`;
const bo_u11 = (match, outcome) => `Кто первым наберет ${outcome.condition} убийств в 4ой карте`;
const bo_v11 = (match, outcome) => `Кто первым наберет ${outcome.condition} убийств в 5ой карте`;
const bo_w11 = (match, outcome) => 'Результат в матче';
const bo_x11 = (match, outcome) => 'Победа в первой карте';
const bo_y11 = (match, outcome) => 'Победа во второй карте';
const bo_z11 = (match, outcome) => 'Победа в третьей карте';
const bo_a12 = (match, outcome) => 'Победа в четвертой карте';
const bo_b12 = (match, outcome) => 'Победа в пятой карте';
const bo_c12 = (match, outcome) => 'First blood в первой карте';
const bo_d12 = (match, outcome) => 'First blood во второй карте';
const bo_e12 = (match, outcome) => 'First blood в третьей карте';
const bo_f12 = (match, outcome) => 'First blood в четвертой карте';
const bo_g12 = (match, outcome) => 'First blood в пятой карте';
const bo_h12 = (match, outcome) => 'Победа с учетом буллитов';
const bo_i12 = (match, outcome) => `${match.homeTeam} выиграет в обоих таймах`;
const bo_j12 = (match, outcome) => `${match.awayTeam} выиграет в обоих таймах`;
const bo_k12 = (match, outcome) => `Команд, забивших ${outcome.conditionTwo} и более голов  (их тотал)`;
const bo_l12 = (match, outcome) => 'Самая результативная команда (её тотал)';
const bo_m12 = (match, outcome) => 'Самый результативный тайм (тотал)';
const bo_n12 = (match, outcome) => `Оба тайма меньше чем ${outcome.condition}`;
const bo_o12 = (match, outcome) => `Оба тайма больше чем ${outcome.condition}`;
const bo_p12 = (match, outcome) => 'Чет/Нечет первого тайма';
const bo_q12 = (match, outcome) => 'Чет/Нечет второго тайма';
const bo_r12 = (match, outcome) => `Сколько голов забьет ${match.homeTeam} в первом тайме?`;
const bo_s12 = (match, outcome) => `Сколько голов забьет ${match.homeTeam} во втором тайме?`;
const bo_t12 = (match, outcome) => `Сколько голов забьет ${match.awayTeam} в первом тайме?`;
const bo_u12 = (match, outcome) => `Сколько голов забьет ${match.awayTeam} во втором тайме?`;
const bo_v12 = (match, outcome) => `Сколько голов забьет ${match.homeTeam} в матче?`;
const bo_w12 = (match, outcome) => `Сколько голов забьет ${match.awayTeam} в матче?`;
const bo_x12 = (match, outcome) => 'Самая нерезультативная команда (её тотал)';
const bo_y12 = (match, outcome) => `Забьет ли ${match.homeTeam} только в первом тайме?`;
const bo_z12 = (match, outcome) => `Забьет ли ${match.awayTeam} только в первом тайме?`;
const bo_a13 = (match, outcome) => `Забьет ли ${match.homeTeam} только во втором тайме?`;
const bo_b13 = (match, outcome) => `Забьет ли ${match.awayTeam} только во втором тайме?`;
const bo_c13 = (match, outcome) => 'Сколько команд забьёт в первом тайме';
const bo_d13 = (match, outcome) => 'Сколько команд забьёт во втором тайме';
const bo_e13 = (match, outcome) => `Сколько команд забьёт больше ${outcome.condition} ${plural(outcome.condition, ['гола', 'голов', 'голов'])}`;
const bo_f13 = (match, outcome) => 'Как будет забит первый гол?';
const bo_g13 = (match, outcome) => 'Выход в следующий круг';
const bo_h13 = (match, outcome) => 'Кто начнет с центра поля?';
const bo_i13 = (match, outcome) => 'Два гола подряд одной командой';
const bo_j13 = (match, outcome) => `${match.homeTeam} одержит волевую победу`;
const bo_k13 = (match, outcome) => `Кто получит ${numeralFemaleEnding(outcome.condition)} ЖК`;
const bo_l13 = (match, outcome) => `${match.awayTeam} одержит волевую победу`;
const bo_m13 = (match, outcome) => 'Что в матче произойдет раньше?';
const bo_n13 = (match, outcome) => 'Дубль';
const bo_o13 = (match, outcome) => 'Хет-трик';
const bo_p13 = (match, outcome) => `Кто подаст ${numeralMaleEnding(outcome.condition)} угловой`;
const bo_q13 = (match, outcome) => `Команд, забивших ровно ${outcome.conditionTwo} ${plural(outcome.conditionTwo, ['гол', 'гола', 'голов'])} (их тотал)`;
const bo_r13 = (match, outcome) => `Забьют ли в матче ровно ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_s13 = (match, outcome) => 'Кто забьет последний гол?';
const bo_t13 = (match, outcome) => 'Автогол';
const bo_u13 = (match, outcome) => 'Забьет ли игрок вышедший на замену?';
const bo_v13 = (match, outcome) => 'Время последнего гола';
const bo_w13 = (match, outcome) => 'Обладатель Кубка';
const bo_x13 = (match, outcome) => 'Обладатель Суперкубка';
const bo_y13 = (match, outcome) => `В каком тайме будет забит ${numeralMaleEnding(outcome.condition)} гол?`;
const bo_z13 = (match, outcome) => 'Двойной исход с 1 по 15 минуту';
const bo_a14 = (match, outcome) => 'Двойной исход с 16 по 30 минуту';
const bo_b14 = (match, outcome) => 'Двойной исход с 31 минуты до перерыва';
const bo_c14 = (match, outcome) => 'Двойной исход с 46 по 60 минуту';
const bo_d14 = (match, outcome) => 'Двойной исход с 61 по 75 минуту';
const bo_e14 = (match, outcome) => 'Двойной исход с 76 минуты до конца ОВ';
const bo_f14 = (match, outcome) => `Забьет ли ${match.homeTeam} ${numeralMaleEnding(outcome.condition)} пенальти? (серия пенальти)`;
const bo_g14 = (match, outcome) => `Забьет ли ${match.awayTeam} ${numeralMaleEnding(outcome.condition)} пенальти? (серия пенальти)`;
const bo_h14 = (match, outcome) => `${match.homeTeam} забьет свой ${numeralMaleEnding(outcome.condition)} гол`;
const bo_i14 = (match, outcome) => `${match.awayTeam} забьет свой ${numeralMaleEnding(outcome.condition)} гол`;
const bo_j14 = (match, outcome) => 'Тотал угловых в первом тайме';
const bo_k14 = (match, outcome) => 'Тотал ЖК в первом тайме';
const bo_l14 = (match, outcome) => 'Фора по угловым в матче';
const bo_m14 = (match, outcome) => 'Фора по угловым в первом тайме';
const bo_n14 = (match, outcome) => 'Фора по ЖК';
const bo_o14 = (match, outcome) => 'Фора по ЖК в первом тайме';
const bo_p14 = (match, outcome) => 'Результат матча по угловым';
const bo_q14 = (match, outcome) => 'Результат первого тайма по угловым';
const bo_r14 = (match, outcome) => 'Результат матча по ЖК';
const bo_s14 = (match, outcome) => 'Результат первого тайма по ЖК';
const bo_t14 = (match, outcome) => `Кто первым забьет ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_u14 = (match, outcome) => `Будет ли забит ${numeralMaleEnding(outcome.condition)} пенальти`;
const bo_v14 = (match, outcome) => 'Ауты';
const bo_w14 = (match, outcome) => 'Тайм-Матч';
const bo_x14 = (match, outcome) => 'Тотал матча (Азия)';
const bo_y14 = (match, outcome) => 'Тотал угловых';
const bo_z14 = (match, outcome) => 'Как закончится матч?';
const bo_a15 = (match, outcome) => 'Пенальти (тотал)';
const bo_b15 = (match, outcome) => 'Тотал красных карточек';
const bo_c15 = (match, outcome) => 'Время первого гола';
const bo_d15 = (match, outcome) => 'Сумма минут голов';
const bo_e15 = (match, outcome) => 'Тотал второго тайма';
const bo_f15 = (match, outcome) => 'Фора во втором тайме';
const bo_g15 = (match, outcome) => 'Удары в створ ворот';
const bo_h15 = (match, outcome) => 'Тотал желтых карточек';
const bo_i15 = (match, outcome) => 'Результат второго тайма';
const bo_j15 = (match, outcome) => 'Фора в матче с 1 по 15 минуту';
const bo_k15 = (match, outcome) => 'Фора в матче с 16 по 30 минуту';
const bo_l15 = (match, outcome) => 'Фора в матче с 31 минуты до перерыва';
const bo_m15 = (match, outcome) => 'Фора в матче с 46 по 60 минуту';
const bo_n15 = (match, outcome) => 'Фора в матче с 61 по 75 минуту';
const bo_o15 = (match, outcome) => 'Фора в матче с 76 минуты до конца ОВ';
const bo_p15 = (match, outcome) => `${match.homeTeam} голы`;
const bo_q15 = (match, outcome) => `${match.awayTeam} голы`;
const bo_r15 = (match, outcome) => 'Тотал замен';
const bo_s15 = (match, outcome) => 'Тотал матча с 1 по 15 минуту';
const bo_t15 = (match, outcome) => 'Тотал матча с 16 по 30 минуту';
const bo_u15 = (match, outcome) => 'Тотал матча с 31 минуты до перерыва';
const bo_v15 = (match, outcome) => 'Тотал матча с 46 по 60 минуту';
const bo_w15 = (match, outcome) => 'Тотал матча с 61 по 75 минуту';
const bo_x15 = (match, outcome) => 'Тотал матча с 76 минуты до конца ОВ';
const bo_y15 = (match, outcome) => `Тотал: ${match.homeTeam} с 1 по 15 минуту`;
const bo_z15 = (match, outcome) => `Тотал: ${match.homeTeam} с 16 по 30 минуту`;
const bo_a16 = (match, outcome) => `Тотал: ${match.homeTeam} с 31 минуты до перерыва`;
const bo_b16 = (match, outcome) => `Тотал: ${match.homeTeam} с 46 по 60 минуту`;
const bo_c16 = (match, outcome) => `Тотал: ${match.homeTeam} с 61 по 75 минуту`;
const bo_d16 = (match, outcome) => `Тотал: ${match.homeTeam} с 76 минуты до конца ОВ`;
const bo_e16 = (match, outcome) => `Тотал: ${match.awayTeam} с 1 по 15 минуту`;
const bo_f16 = (match, outcome) => `Тотал: ${match.awayTeam} с 16 по 30 минуту`;
const bo_g16 = (match, outcome) => `Тотал: ${match.awayTeam} с 31 минуты до перерыва`;
const bo_h16 = (match, outcome) => `Тотал: ${match.awayTeam} с 46 по 60 минуту`;
const bo_i16 = (match, outcome) => `Тотал: ${match.awayTeam} с 61 по 75 минуту`;
const bo_j16 = (match, outcome) => `Тотал: ${match.awayTeam} с 76 минуты до конца ОВ`;
const bo_k16 = (match, outcome) => 'Точный тотал первого тайма';
const bo_l16 = (match, outcome) => 'Точный тотал второго тайма';
const bo_m16 = (match, outcome) => `${match.homeTeam} выиграет и не пропустит`;
const bo_n16 = (match, outcome) => `${match.awayTeam} выиграет и не пропустит`;
const bo_o16 = (match, outcome) => `${match.homeTeam} забьет ровно ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_p16 = (match, outcome) => `${match.awayTeam} забьет ровно ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`;
const bo_q16 = (match, outcome) => 'Точный счет первого тайма';
const bo_r16 = (match, outcome) => 'Точный счет второго тайма';
const bo_s16 = (match, outcome) => 'Тотал не забитых пенальти';
const bo_t16 = (match, outcome) => `Обе команды забьют меньше чем ${outcome.condition}`;
const bo_u16 = (match, outcome) => `Обе команды забьют больше чем ${outcome.condition}`;
const bo_v16 = (match, outcome) => 'Сравнение таймов (голы)';
const bo_w16 = (match, outcome) => 'Победа в матче с 1 по 15 минуту';
const bo_x16 = (match, outcome) => 'Победа в матче с 16 по 30 минуту';
const bo_y16 = (match, outcome) => 'Победа в матче с 31 минуты до перерыва';
const bo_z16 = (match, outcome) => 'Победа в матче с 46 по 60 минуту';
const bo_a17 = (match, outcome) => 'Победа в матче с 61 по 75 минуту';
const bo_b17 = (match, outcome) => 'Победа в матче с 76 минуты до конца ОВ';
const bo_c17 = (match, outcome) => `${match.homeTeam} выиграет в одном из таймов`;
const bo_d17 = (match, outcome) => `${match.awayTeam} выиграет в одном из таймов`;
const bo_e17 = (match, outcome) => `Команд, забивших от ${outcome.conditionTwo} до ${outcome.conditionThree} голов (их тотал)`;
const bo_f17 = (match, outcome) => `Тотал: ${match.homeTeam} во втором тайме`;
const bo_g17 = (match, outcome) => `Тотал: ${match.awayTeam} во втором тайме`;
const bo_h17 = (match, outcome) => `Забьет ли ${outcome.playerName} (${match.homeTeam}) гол?`;
const bo_i17 = (match, outcome) => `Забьет ли ${outcome.playerName} (${match.awayTeam}) гол?`;
const bo_j17 = (match, outcome) => 'Результат матча';
const bo_k17 = (match, outcome) => 'Фора матча';
const bo_l17 = (match, outcome) => 'Тотал хозяев';
const bo_m17 = (match, outcome) => 'Тотал гостей';
const bo_n17 = (match, outcome) => 'Тотал самого результативного матча';
const bo_o17 = (match, outcome) => 'Тотал самого НЕрезультативного матча';
const bo_p17 = (match, outcome) => 'Тотал матчей без голов';
const bo_q17 = (match, outcome) => 'Тотал побед хозяев';
const bo_r17 = (match, outcome) => 'Тотал побед гостей';
const bo_s17 = (match, outcome) => 'Тотал ничьих';
const bo_t17 = (match, outcome) => 'Обе команды забьют: 1 тайм/2 тайм';
const bo_u17 = (match, outcome) => `Тотал ${outcome.condition} и Обе забьют`;
const bo_v17 = (match, outcome) => `${match.homeTeam} забьет и не выиграет`;
const bo_w17 = (match, outcome) => `${match.awayTeam} забьет и не выиграет`;
const bo_x17 = (match, outcome) => 'Метод победы в матче';
const bo_y17 = (match, outcome) => 'Компенсированное время в 1ом тайме';
const bo_z17 = (match, outcome) => 'Компенсированное время во 2ом тайме';
const bo_a18 = (match, outcome) => 'Будет ли в матче штанга/перекладина';
const bo_b18 = (match, outcome) => 'Время первой замены';
const bo_c18 = (match, outcome) => `Красную карточку получит игрок ${match.homeTeam}`;
const bo_d18 = (match, outcome) => `Красную карточку получит игрок ${match.awayTeam}`;
const bo_e18 = (match, outcome) => 'Будет ли пенальти и удаление';
const bo_f18 = (match, outcome) => 'Гол в компенсированное время';
const bo_g18 = (match, outcome) => 'ЖК за симуляцию';
const bo_h18 = (match, outcome) => 'ЖК за снятую футболку';
const bo_i18 = (match, outcome) => 'Угловые с каждого флажка';
const bo_j18 = (match, outcome) => 'Кто займет 3-е место?';
const bo_k18 = (match, outcome) => `Тотал: ${match.awayTeam}  (Доп.время)`;
const bo_l18 = (match, outcome) => `Тотал: ${match.homeTeam}  (Доп.время)`;
const bo_m18 = (match, outcome) => 'Двойной исход (Доп.время)';
const bo_n18 = (match, outcome) => 'Точный счет  (Доп.время)';
const bo_o18 = (match, outcome) => 'Фора (Доп.время)';
const bo_p18 = (match, outcome) => 'Тотал  (Доп.время)';
const bo_q18 = (match, outcome) => 'Результат (Доп.время)';
const bo_r18 = (match, outcome) => `Кто забьет ${numeralMaleEnding(outcome.condition)} гол в доп.в.?`;
const bo_s18 = (match, outcome) => 'Фора в первом дополнительном времени';
const bo_t18 = (match, outcome) => 'Тотал первого дополнительного  времени';
const bo_u18 = (match, outcome) => 'Результат в первом дополнительном времени';
const bo_v18 = (match, outcome) => 'Фора во втором дополнительном времени';
const bo_w18 = (match, outcome) => 'Тотал второго дополнительного  времени';
const bo_x18 = (match, outcome) => 'Результат во второе дополнительное время';
const bo_y18 = (match, outcome) => 'Точный счет в серии пенальти';
const bo_z18 = (match, outcome) => `Тотал забитых пенальти: ${match.awayTeam} (серия пенальти)`;
const bo_a19 = (match, outcome) => `Тотал забитых пенальти: ${match.homeTeam} (серия пенальти)`;
const bo_b19 = (match, outcome) => 'Тотал забитых пенальти (серия пенальти)';
const bo_c19 = (match, outcome) => 'Тотал незабитых пенальти (серия пенальти)';
const bo_d19 = (match, outcome) => `Европейская фора ${europeanHandicapCondition(outcome.condition)}`;
const bo_e19 = (match, outcome) => `Европейская фора ${europeanHandicapCondition(outcome.condition)} в 1ом тайме`;
const bo_f19 = (match, outcome) => `Европейская фора ${europeanHandicapCondition(outcome.condition)} во 2ом тайме`;
const bo_g19 = (match, outcome) => `Кто забьет ${numeralMaleEnding(outcome.condition)} гол в первом тайме?`;
const bo_h19 = (match, outcome) => `Остаток матча (текущий счет ${outcome.condition}:${outcome.conditionTwo})`;
const bo_i19 = (match, outcome) => `Остаток первого тайма (текущий счет ${outcome.condition}:${outcome.conditionTwo})`;
const bo_j19 = (match, outcome) => `Тотал угловых в первом тайме: ${match.homeTeam}`;
const bo_k19 = (match, outcome) => `Тотал угловых в первом тайме: ${match.awayTeam}`;
const bo_l19 = (match, outcome) => `Тотал угловых: ${match.homeTeam}`;
const bo_m19 = (match, outcome) => `Тотал угловых: ${match.awayTeam}`;
const bo_n19 = (match, outcome) => 'Время первого гола (мин)';
const bo_o19 = (match, outcome) => 'Двойной исход первого тайма';
const bo_p19 = (match, outcome) => 'Двойной исход второго тайма';
const bo_q19 = (match, outcome) => 'Обе забьют?';
const bo_r19 = (match, outcome) => 'не забитых пенальти';
const bo_s19 = (match, outcome) => `Победа ${match.homeTeam} с разницей в первом тайме`;
const bo_t19 = (match, outcome) => `Победа ${match.homeTeam} с разницей во втором тайме`;
const bo_u19 = (match, outcome) => `Победа ${match.awayTeam} с разницей в первом тайме`;
const bo_v19 = (match, outcome) => `Победа ${match.awayTeam} с разницей во втором тайме`;
const bo_w19 = (match, outcome) => 'Хет-трики (их тотал)';
const bo_x19 = (match, outcome) => 'Чет/Нечет первого периода';
const bo_y19 = (match, outcome) => 'Чет/Нечет второго периода';
const bo_z19 = (match, outcome) => 'Чет/Нечет третьего периода';
const bo_a20 = (match, outcome) => 'Самый результативный период (тотал)';
const bo_b20 = (match, outcome) => 'Самый нерезультативный период (тотал)';
const bo_c20 = (match, outcome) => 'Точный тотал первого периода';
const bo_d20 = (match, outcome) => 'Точный тотал второго периода';
const bo_e20 = (match, outcome) => 'Точный тотал третьего периода';
const bo_f20 = (match, outcome) => `Тотал: ${match.homeTeam} в первом периоде`;
const bo_g20 = (match, outcome) => `Тотал: ${match.homeTeam} во втором периоде`;
const bo_h20 = (match, outcome) => `Тотал: ${match.homeTeam} в третьем периоде`;
const bo_i20 = (match, outcome) => `Тотал: ${match.awayTeam} в первом периоде`;
const bo_j20 = (match, outcome) => `Тотал: ${match.awayTeam} во втором периоде`;
const bo_k20 = (match, outcome) => `Тотал: ${match.awayTeam} в третьем периоде`;
const bo_l20 = (match, outcome) => 'Обе команды забьют';
const bo_m20 = (match, outcome) => `Забьет ли ${match.homeTeam} ${numeralMaleEnding(outcome.condition)} буллит?`;
const bo_n20 = (match, outcome) => `Забьет ли ${match.awayTeam} ${numeralMaleEnding(outcome.condition)} буллит?`;
const bo_o20 = (match, outcome) => 'Победа с учетом ОТ';
const bo_p20 = (match, outcome) => `${match.homeTeam} забьет в каждом периоде`;
const bo_q20 = (match, outcome) => `${match.awayTeam} забьет в каждом периоде`;
const bo_r20 = (match, outcome) => 'Забьют во всех периодах';
const bo_s20 = (match, outcome) => 'Сравнение первого и второго периода';
const bo_t20 = (match, outcome) => 'Сравнение первого и третьего периода';
const bo_u20 = (match, outcome) => 'Сравнение второго и третьего периода';
const bo_v20 = (match, outcome) => `${match.homeTeam} победит в одном из периодов`;
const bo_w20 = (match, outcome) => `${match.awayTeam} победит в одном из периодов`;
const bo_x20 = (match, outcome) => 'Ничья хоты бы в одном периоде';
const bo_y20 = (match, outcome) => 'Победа в матче с 1 по 10 минуту';
const bo_z20 = (match, outcome) => 'Победа в матче с 11 по 20 минуту';
const bo_a21 = (match, outcome) => 'Победа в матче с 21 по 30 минуту';
const bo_b21 = (match, outcome) => 'Победа в матче с 31 по 40 минуту';
const bo_c21 = (match, outcome) => 'Победа в матче с 41 по 50 минуту';
const bo_d21 = (match, outcome) => 'Победа в матче с 51 по 60 минуту';
const bo_e21 = (match, outcome) => 'Фора в матче с 1 по 10 минуту';
const bo_f21 = (match, outcome) => 'Фора в матче с 11 по 20 минуту';
const bo_g21 = (match, outcome) => 'Фора в матче с 21 по 30 минуту';
const bo_h21 = (match, outcome) => 'Фора в матче с 31 по 40 минуту';
const bo_i21 = (match, outcome) => 'Фора в матче с 41 по 50 минуту';
const bo_j21 = (match, outcome) => 'Фора в матче с 51 по 60 минуту';
const bo_k21 = (match, outcome) => 'Тотал матча с 1 по 10 минуту';
const bo_l21 = (match, outcome) => 'Тотал матча с 11 по 20 минуту';
const bo_m21 = (match, outcome) => 'Тотал матча с 21 по 30 минуту';
const bo_n21 = (match, outcome) => 'Тотал матча с 31 по 40 минуту';
const bo_o21 = (match, outcome) => 'Тотал матча с 41 по 50 минуту';
const bo_p21 = (match, outcome) => 'Тотал матча с 51 по 60 минуту';
const bo_q21 = (match, outcome) => 'Чет/Нечет наибольшего выпавшего шара';
const bo_r21 = (match, outcome) => 'Чет/Нечет наименьшего выпавшего шара';
const bo_s21 = (match, outcome) => 'Чет/Нечет первого выпавшего шара';
const bo_t21 = (match, outcome) => 'Чет/Нечет последнего выпавшего шара';
const bo_u21 = (match, outcome) => 'Первый меньше/больше последнего';
const bo_v21 = (match, outcome) => 'Все шары четные';
const bo_w21 = (match, outcome) => 'Все шары нечетные';
const bo_x21 = (match, outcome) => 'Хотя бы два шара с соседними номерами';
const bo_y21 = (match, outcome) => 'Наименьший выпавший шар';
const bo_z21 = (match, outcome) => 'Наибольший выпавший шар';
const bo_a22 = (match, outcome) => 'Сумма выпавших шаров';
const bo_b22 = (match, outcome) => `Хотя бы один из выпавших шаров кратен ${outcome.condition}`;
const bo_c22 = (match, outcome) => 'Разница между наименьшим и наибольшим шарами';
const bo_d22 = (match, outcome) => 'Сумма нечетных шаров';
const bo_e22 = (match, outcome) => 'Сумма четных шаров';
const bo_f22 = (match, outcome) => 'Первый выпавший шар';
const bo_g22 = (match, outcome) => 'Второй выпавший шар';
const bo_h22 = (match, outcome) => 'Третий выпавший шар';
const bo_i22 = (match, outcome) => 'Четвертый выпавший шар';
const bo_j22 = (match, outcome) => 'Пятый выпавший шар';
const bo_k22 = (match, outcome) => 'Шестой выпавший шар';
const bo_l22 = (match, outcome) => 'Седьмой выпавший шар';
const bo_m22 = (match, outcome) => `Хотя бы один шар попадет в интервал от ${outcome.condition} до ${outcome.conditionTwo}`;
const bo_n22 = (match, outcome) => 'Сумма наименьшего и наибольшего шаров';
const bo_o22 = (match, outcome) => `${match.homeTeam} победит Болевым/Удушающим/Добровольной сдачей`;
const bo_p22 = (match, outcome) => `${match.awayTeam} победит Болевым/Удушающим/Добровольной сдачей`;
const bo_q22 = (match, outcome) => `${match.homeTeam} победит Нокаутом/Технич. нокаутом/Дисквалификацией`;
const bo_r22 = (match, outcome) => `${match.awayTeam} победит Нокаутом/Технич. нокаутом/Дисквалификацией`;
const bo_s22 = (match, outcome) => 'Тотал медалей';
const bo_t22 = (match, outcome) => 'Результат двадцать девятой партии';
const bo_u22 = (match, outcome) => 'Результат тридцатой партии';
const bo_v22 = (match, outcome) => 'Результат тридцать первой партии';
const bo_w22 = (match, outcome) => 'Результат тридцать второй партии';
const bo_x22 = (match, outcome) => 'Результат тридцать третьей партии';
const bo_y22 = (match, outcome) => 'Результат тридцать четвертой партии';
const bo_z22 = (match, outcome) => 'Результат тридцать пятой партии';
const bo_a23 = (match, outcome) => 'Результат тридцать шестой партии';
const bo_b23 = (match, outcome) => 'Результат тридцать седьмой партии';
const bo_c23 = (match, outcome) => 'Чет/Нечет восемнадцатой партии';
const bo_d23 = (match, outcome) => 'Чет/Нечет девятнадцатой партии';
const bo_e23 = (match, outcome) => 'Чет/Нечет двадцатой партии';
const bo_f23 = (match, outcome) => 'Чет/Нечет двадцать первой партии';
const bo_g23 = (match, outcome) => 'Чет/Нечет двадцать второй партии';
const bo_h23 = (match, outcome) => 'Чет/Нечет двадцать третьей партии';
const bo_i23 = (match, outcome) => 'Чет/Нечет двадцать четвертой партии';
const bo_j23 = (match, outcome) => 'Чет/Нечет двадцать пятой партии';
const bo_k23 = (match, outcome) => 'Чет/Нечет двадцать шестой партии';
const bo_l23 = (match, outcome) => 'Чет/Нечет двадцать седьмой партии';
const bo_m23 = (match, outcome) => 'Чет/Нечет двадцать восьмой партии';
const bo_n23 = (match, outcome) => 'Чет/Нечет двадцать девятой партии';
const bo_o23 = (match, outcome) => 'Чет/Нечет тридцатой партии';
const bo_p23 = (match, outcome) => 'Чет/Нечет тридцать первой партии';
const bo_q23 = (match, outcome) => 'Чет/Нечет тридцать второй партии';
const bo_r23 = (match, outcome) => 'Чет/Нечет тридцать третьей партии';
const bo_s23 = (match, outcome) => 'Чет/Нечет тридцать четвертой партии';
const bo_t23 = (match, outcome) => 'Чет/Нечет тридцать пятой партии';
const bo_u23 = (match, outcome) => 'Чет/Нечет тридцать шестой партии';
const bo_v23 = (match, outcome) => 'Чет/Нечет тридцать седьмой партии';
const bo_w23 = (match, outcome) => 'Какой цветной шар будет забит первым в первой партии?';
const bo_x23 = (match, outcome) => 'Какой цветной шар будет забит первым во второй партии?';
const bo_y23 = (match, outcome) => 'Какой цветной шар будет забит первым в третьей партии?';
const bo_z23 = (match, outcome) => 'Какой цветной шар будет забит первым в четвертой партии?';
const bo_a24 = (match, outcome) => 'Какой цветной шар будет забит первым в пятой партии?';
const bo_b24 = (match, outcome) => 'Какой цветной шар будет забит первым в шестой партии?';
const bo_c24 = (match, outcome) => 'Какой цветной шар будет забит первым в седьмой партии?';
const bo_d24 = (match, outcome) => 'Какой цветной шар будет забит первым в восьмой партии?';
const bo_e24 = (match, outcome) => 'Какой цветной шар будет забит первым в девятой партии?';
const bo_f24 = (match, outcome) => 'Какой цветной шар будет забит первым в десятой партии?';
const bo_g24 = (match, outcome) => 'Какой цветной шар будет забит первым в одиннадцатой партии?';
const bo_h24 = (match, outcome) => 'Какой цветной шар будет забит первым в двенадцатой партии?';
const bo_i24 = (match, outcome) => 'Какой цветной шар будет забит первым в тринадцатой партии?';
const bo_j24 = (match, outcome) => 'Какой цветной шар будет забит первым в четырнадцатой партии?';
const bo_k24 = (match, outcome) => 'Какой цветной шар будет забит первым в пятнадцатой партии?';
const bo_l24 = (match, outcome) => 'Какой цветной шар будет забит первым в шестнадцатой партии?';
const bo_m24 = (match, outcome) => 'Какой цветной шар будет забит первым в семнадцатой партии?';
const bo_n24 = (match, outcome) => 'Какой цветной шар будет забит первым в восемнадцатой партии?';
const bo_o24 = (match, outcome) => 'Какой цветной шар будет забит первым в девятнадцатой партии?';
const bo_p24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцатой партии?';
const bo_q24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать первой партии?';
const bo_r24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать второй партии?';
const bo_s24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать третьей партии?';
const bo_t24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать четвертой партии?';
const bo_u24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать пятой партии?';
const bo_v24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать шестой партии?';
const bo_w24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать седьмой партии?';
const bo_x24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать восьмой партии?';
const bo_y24 = (match, outcome) => 'Какой цветной шар будет забит первым в двадцать девятой партии?';
const bo_z24 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцатой партии?';
const bo_a25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать первой партии?';
const bo_b25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать второй партии?';
const bo_c25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать третьей партии?';
const bo_d25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать четвертой партии?';
const bo_e25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать пятой партии?';
const bo_f25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать шестой партии?';
const bo_g25 = (match, outcome) => 'Какой цветной шар будет забит первым в тридцать седьмой партии?';
const bo_h25 = (match, outcome) => 'Результат первой партии';
const bo_i25 = (match, outcome) => 'Результат второй партии';
const bo_j25 = (match, outcome) => 'Результат третьей партии';
const bo_k25 = (match, outcome) => 'Результат четвертой партии';
const bo_l25 = (match, outcome) => 'Результат пятой партии';
const bo_m25 = (match, outcome) => 'Результат шестой партии';
const bo_n25 = (match, outcome) => 'Результат седьмой партии';
const bo_o25 = (match, outcome) => 'Результат восьмой партии';
const bo_p25 = (match, outcome) => 'Результат девятой партии';
const bo_q25 = (match, outcome) => 'Результат десятой партии';
const bo_r25 = (match, outcome) => 'Результат одиннадцатой партии';
const bo_s25 = (match, outcome) => 'Результат двенадцатой партии';
const bo_t25 = (match, outcome) => 'Результат тринадцатой партии';
const bo_u25 = (match, outcome) => 'Результат четырнадцатой партии';
const bo_v25 = (match, outcome) => 'Результат пятнадцатой партии';
const bo_w25 = (match, outcome) => 'Результат шестнадцатой партии';
const bo_x25 = (match, outcome) => 'Результат семнадцатой партии';
const bo_y25 = (match, outcome) => 'Результат восемнадцатой партии';
const bo_z25 = (match, outcome) => 'Результат девятнадцатой партии';
const bo_a26 = (match, outcome) => 'Результат двадцатой партии';
const bo_b26 = (match, outcome) => 'Результат двадцать первой партии';
const bo_c26 = (match, outcome) => 'Результат двадцать второй партии';
const bo_d26 = (match, outcome) => 'Результат двадцать третьей партии';
const bo_e26 = (match, outcome) => 'Результат двадцать четвертой партии';
const bo_f26 = (match, outcome) => 'Результат двадцать пятой партии';
const bo_g26 = (match, outcome) => 'Результат двадцать шестой партии';
const bo_h26 = (match, outcome) => 'Результат двадцать седьмой партии';
const bo_i26 = (match, outcome) => 'Результат двадцать восьмой партии';
const bo_j26 = (match, outcome) => 'Кто первым(ой) забьет шар в седьмой партии ?';
const bo_k26 = (match, outcome) => 'Кто первым(ой) забьет шар в восьмой партии ?';
const bo_l26 = (match, outcome) => 'Кто первым(ой) забьет шар в девятой партии ?';
const bo_m26 = (match, outcome) => 'Кто первым(ой) забьет шар в десятой партии ?';
const bo_n26 = (match, outcome) => 'Кто первым(ой) забьет шар в одиннадцатой партии ?';
const bo_o26 = (match, outcome) => 'Кто первым(ой) забьет шар в двенадцатой партии ?';
const bo_p26 = (match, outcome) => 'Кто первым(ой) забьет шар в тринадцатой партии ?';
const bo_q26 = (match, outcome) => 'Кто первым(ой) забьет шар в четырнадцатой партии ?';
const bo_r26 = (match, outcome) => 'Кто первым(ой) забьет шар в пятнадцатой партии ?';
const bo_s26 = (match, outcome) => 'Кто первым(ой) забьет шар в шестнадцатой партии ?';
const bo_t26 = (match, outcome) => 'Кто первым(ой) забьет шар в семнадцатой партии ?';
const bo_u26 = (match, outcome) => 'Кто первым(ой) забьет шар в восемнадцатой партии ?';
const bo_v26 = (match, outcome) => 'Кто первым(ой) забьет шар в девятнадцатой партии ?';
const bo_w26 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцатой партии ?';
const bo_x26 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать первой партии ?';
const bo_y26 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать второй партии ?';
const bo_z26 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать третьей партии ?';
const bo_a27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать четвертой партии ?';
const bo_b27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать пятой партии ?';
const bo_c27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать шестой партии ?';
const bo_d27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать седьмой партии ?';
const bo_e27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать восьмой партии ?';
const bo_f27 = (match, outcome) => 'Кто первым(ой) забьет шар в двадцать девятой партии ?';
const bo_g27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцатой партии ?';
const bo_h27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать первой партии ?';
const bo_i27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать второй партии ?';
const bo_j27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать третьей партии ?';
const bo_k27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать четвертой партии ?';
const bo_l27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать пятой партии ?';
const bo_m27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать шестой партии ?';
const bo_n27 = (match, outcome) => 'Кто первым(ой) забьет шар в тридцать седьмой партии ?';
const bo_o27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в первой партии`;
const bo_p27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во второй партии`;
const bo_q27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в третьей партии`;
const bo_r27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в четвертой партии`;
const bo_s27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в пятой партии`;
const bo_t27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в шестой партии`;
const bo_u27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в седьмой партии`;
const bo_v27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в восьмой партии`;
const bo_w27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в девятой партии`;
const bo_x27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в десятой партии`;
const bo_y27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в одиннадцатой партии`;
const bo_z27 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двенадцатой партии`;
const bo_a28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тринадцатой партии`;
const bo_b28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в четырнадцатой партии`;
const bo_c28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в пятнадцатой партии`;
const bo_d28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в шестнадцатой партии`;
const bo_e28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в семнадцатой партии`;
const bo_f28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в восемнадцатой партии`;
const bo_g28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в девятнадцатой партии`;
const bo_h28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцатой партии`;
const bo_i28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать первой партии`;
const bo_j28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать второй партии`;
const bo_k28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать третьей партии`;
const bo_l28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать четвертой партии`;
const bo_m28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать пятой партии`;
const bo_n28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать шестой партии`;
const bo_o28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать седьмой партии`;
const bo_p28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать восьмой партии`;
const bo_q28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в двадцать девятой партии`;
const bo_r28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцатой партии`;
const bo_s28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать первой партии`;
const bo_t28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать второй партии`;
const bo_u28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать третьей партии`;
const bo_v28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать четвертой партии`;
const bo_w28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать пятой партии`;
const bo_x28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать шестой партии`;
const bo_y28 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в тридцать седьмой партии`;
const bo_z28 = (match, outcome) => 'Чет/Нечет первой партии';
const bo_a29 = (match, outcome) => 'Чет/Нечет второй партии';
const bo_b29 = (match, outcome) => 'Чет/Нечет третьей партии';
const bo_c29 = (match, outcome) => 'Чет/Нечет четвертой партии';
const bo_d29 = (match, outcome) => 'Чет/Нечет пятой партии';
const bo_e29 = (match, outcome) => 'Чет/Нечет шестой партии';
const bo_f29 = (match, outcome) => 'Чет/Нечет седьмой партии';
const bo_g29 = (match, outcome) => 'Чет/Нечет восьмой партии';
const bo_h29 = (match, outcome) => 'Чет/Нечет девятой партии';
const bo_i29 = (match, outcome) => 'Чет/Нечет десятой партии';
const bo_j29 = (match, outcome) => 'Чет/Нечет одиннадцатой партии';
const bo_k29 = (match, outcome) => 'Чет/Нечет двенадцатой партии';
const bo_l29 = (match, outcome) => 'Чет/Нечет тринадцатой партии';
const bo_m29 = (match, outcome) => 'Чет/Нечет четырнадцатой партии';
const bo_n29 = (match, outcome) => 'Чет/Нечет пятнадцатой партии';
const bo_o29 = (match, outcome) => 'Чет/Нечет шестнадцатой партии';
const bo_p29 = (match, outcome) => 'Чет/Нечет семнадцатой партии';
const bo_q29 = (match, outcome) => 'Тотал сенчури брейков в матче';
const bo_r29 = (match, outcome) => 'Фора в первой партии';
const bo_s29 = (match, outcome) => 'Фора во второй партии';
const bo_t29 = (match, outcome) => 'Фора в третьей партии';
const bo_u29 = (match, outcome) => 'Фора в четвертой партии';
const bo_v29 = (match, outcome) => 'Фора в пятой партии';
const bo_w29 = (match, outcome) => 'Фора в шестой партии';
const bo_x29 = (match, outcome) => 'Фора в седьмой партии';
const bo_y29 = (match, outcome) => 'Фора в восьмой партии';
const bo_z29 = (match, outcome) => 'Фора в девятой партии';
const bo_a30 = (match, outcome) => 'Фора в десятой партии';
const bo_b30 = (match, outcome) => 'Фора в одиннадцатой партии';
const bo_c30 = (match, outcome) => 'Фора в двенадцатой партии';
const bo_d30 = (match, outcome) => 'Фора в тринадцатой партии';
const bo_e30 = (match, outcome) => 'Фора в четырнадцатой партии';
const bo_f30 = (match, outcome) => 'Фора в пятнадцатой партии';
const bo_g30 = (match, outcome) => 'Фора в шестнадцатой партии';
const bo_h30 = (match, outcome) => 'Фора в семнадцатой партии';
const bo_i30 = (match, outcome) => 'Фора в восемнадцатой партии';
const bo_j30 = (match, outcome) => 'Фора в девятнадцатой партии';
const bo_k30 = (match, outcome) => 'Фора в двадцатой партии';
const bo_l30 = (match, outcome) => 'Фора в двадцать первой партии';
const bo_m30 = (match, outcome) => 'Фора в двадцать второй партии';
const bo_n30 = (match, outcome) => 'Фора в двадцать третьей партии';
const bo_o30 = (match, outcome) => 'Фора в двадцать четвертой партии';
const bo_p30 = (match, outcome) => 'Фора в двадцать пятой партии';
const bo_q30 = (match, outcome) => 'Фора в двадцать шестой партии';
const bo_r30 = (match, outcome) => 'Фора в двадцать седьмой партии';
const bo_s30 = (match, outcome) => 'Фора в двадцать восьмой партии';
const bo_t30 = (match, outcome) => 'Фора в двадцать девятой партии';
const bo_u30 = (match, outcome) => 'Фора в тридцатой партии';
const bo_v30 = (match, outcome) => 'Фора в тридцать первой партии';
const bo_w30 = (match, outcome) => 'Фора в тридцать второй партии';
const bo_x30 = (match, outcome) => 'Фора в тридцать третьей партии';
const bo_y30 = (match, outcome) => 'Фора в тридцать четвертой партии';
const bo_z30 = (match, outcome) => 'Фора в тридцать пятой партии';
const bo_a31 = (match, outcome) => 'Фора в тридцать шестой партии';
const bo_b31 = (match, outcome) => 'Фора в тридцать седьмой партии';
const bo_c31 = (match, outcome) => 'Тотал первой партии';
const bo_d31 = (match, outcome) => 'Тотал второй партии';
const bo_e31 = (match, outcome) => 'Тотал третьей партии';
const bo_f31 = (match, outcome) => 'Тотал четвертой партии';
const bo_g31 = (match, outcome) => 'Тотал пятой партии';
const bo_h31 = (match, outcome) => 'Тотал шестой партии';
const bo_i31 = (match, outcome) => 'Тотал седьмой партии';
const bo_j31 = (match, outcome) => 'Тотал восьмой партии';
const bo_k31 = (match, outcome) => 'Тотал девятой партии';
const bo_l31 = (match, outcome) => 'Тотал десятой партии';
const bo_m31 = (match, outcome) => 'Тотал одиннадцатой партии';
const bo_n31 = (match, outcome) => 'Тотал двенадцатой партии';
const bo_o31 = (match, outcome) => 'Тотал тринадцатой партии';
const bo_p31 = (match, outcome) => 'Тотал четырнадцатой партии';
const bo_q31 = (match, outcome) => 'Тотал пятнадцатой партии';
const bo_r31 = (match, outcome) => 'Тотал шестнадцатой партии';
const bo_s31 = (match, outcome) => 'Тотал семнадцатой партии';
const bo_t31 = (match, outcome) => 'Тотал восемнадцатой партии';
const bo_u31 = (match, outcome) => 'Тотал девятнадцатой партии';
const bo_v31 = (match, outcome) => 'Тотал двадцатой партии';
const bo_w31 = (match, outcome) => 'Тотал двадцать первой партии';
const bo_x31 = (match, outcome) => 'Тотал двадцать второй партии';
const bo_y31 = (match, outcome) => 'Тотал двадцать третьей партии';
const bo_z31 = (match, outcome) => 'Тотал двадцать четвертой партии';
const bo_a32 = (match, outcome) => 'Тотал двадцать пятой партии';
const bo_b32 = (match, outcome) => 'Тотал двадцать шестой партии';
const bo_c32 = (match, outcome) => 'Тотал двадцать седьмой партии';
const bo_d32 = (match, outcome) => 'Тотал двадцать восьмой партии';
const bo_e32 = (match, outcome) => 'Тотал двадцать девятой партии';
const bo_f32 = (match, outcome) => 'Тотал тридцатой партии';
const bo_g32 = (match, outcome) => 'Тотал тридцать первой партии';
const bo_h32 = (match, outcome) => 'Тотал тридцать второй партии';
const bo_i32 = (match, outcome) => 'Тотал тридцать третьей партии';
const bo_j32 = (match, outcome) => 'Тотал тридцать четвертой партии';
const bo_k32 = (match, outcome) => 'Тотал тридцать пятой партии';
const bo_l32 = (match, outcome) => 'Тотал тридцать шестой партии';
const bo_m32 = (match, outcome) => 'Тотал тридцать седьмой партии';
const bo_n32 = (match, outcome) => 'Кто первым(ой) забьет шар в первой партии ?';
const bo_o32 = (match, outcome) => 'Кто первым(ой) забьет шар во второй партии ?';
const bo_p32 = (match, outcome) => 'Кто первым(ой) забьет шар в третьей партии ?';
const bo_q32 = (match, outcome) => 'Кто первым(ой) забьет шар в четвертой партии ?';
const bo_r32 = (match, outcome) => 'Кто первым(ой) забьет шар в пятой партии ?';
const bo_s32 = (match, outcome) => 'Кто первым(ой) забьет шар в шестой партии ?';
const bo_t32 = (match, outcome) => 'Тотал партий в матче';
const bo_u32 = (match, outcome) => `Тотал: ${match.homeTeam} в первой партии`;
const bo_v32 = (match, outcome) => `Тотал: ${match.homeTeam} во второй партии`;
const bo_w32 = (match, outcome) => `Тотал: ${match.homeTeam} в третьей партии`;
const bo_x32 = (match, outcome) => `Тотал: ${match.homeTeam} в четвертой партии`;
const bo_y32 = (match, outcome) => `Тотал: ${match.homeTeam} в пятой партии`;
const bo_z32 = (match, outcome) => `Тотал: ${match.homeTeam} в шестой партии`;
const bo_a33 = (match, outcome) => `Тотал: ${match.homeTeam} в седьмой партии`;
const bo_b33 = (match, outcome) => `Тотал: ${match.awayTeam} в первой партии`;
const bo_c33 = (match, outcome) => `Тотал: ${match.awayTeam} во второй партии`;
const bo_d33 = (match, outcome) => `Тотал: ${match.awayTeam} в третьей партии`;
const bo_e33 = (match, outcome) => `Тотал: ${match.awayTeam} в четвертой партии`;
const bo_f33 = (match, outcome) => `Тотал: ${match.awayTeam} в пятой партии`;
const bo_g33 = (match, outcome) => `Тотал: ${match.awayTeam} в шестой партии`;
const bo_h33 = (match, outcome) => `Тотал: ${match.awayTeam} в седьмой партии`;
const bo_i33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 1ой партии`;
const bo_j33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во 2ой партии`;
const bo_k33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 3ей партии`;
const bo_l33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 4ой партии`;
const bo_m33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во 5ой партии`;
const bo_n33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 6ой партии`;
const bo_o33 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в 7ой партии`;
const bo_p33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в первой партии`;
const bo_q33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во второй партии`;
const bo_r33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в третьей партии`;
const bo_s33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в четвертой партии`;
const bo_t33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в пятой партии`;
const bo_u33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в шестой партии`;
const bo_v33 = (match, outcome) => `${match.homeTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в седьмой партии`;
const bo_w33 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в первой партии`;
const bo_x33 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} во второй партии`;
const bo_y33 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в третьей партии`;
const bo_z33 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в четвертой партии`;
const bo_a34 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в пятой партии`;
const bo_b34 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в шестой партии`;
const bo_c34 = (match, outcome) => `${match.awayTeam} победит ровно в ${outcome.condition} ${plural(outcome.condition, ['очко', 'очка', 'очков'])} в седьмой партии`;
const bo_d34 = (match, outcome) => 'Точный тотал первой партии';
const bo_e34 = (match, outcome) => 'Точный тотал второй партии';
const bo_f34 = (match, outcome) => 'Точный тотал третьей партии';
const bo_g34 = (match, outcome) => 'Точный тотал четвертой партии';
const bo_h34 = (match, outcome) => 'Точный тотал пятой партии';
const bo_i34 = (match, outcome) => 'Точный тотал шестой партии';
const bo_j34 = (match, outcome) => 'Точный тотал седьмой партии';
const bo_k34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в первой партии`;
const bo_l34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко во второй партии`;
const bo_m34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в третьей партии`;
const bo_n34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в четвертой партии`;
const bo_o34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в пятой партии`;
const bo_p34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в шестой партии`;
const bo_q34 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в седьмой партии`;
const bo_r34 = (match, outcome) => 'Чет/Нечет тотала первого периода';
const bo_s34 = (match, outcome) => 'Чет/Нечет тотала второго периода';
const bo_t34 = (match, outcome) => 'Чет/Нечет тотала третьего периода';
const bo_u34 = (match, outcome) => 'Чет/Нечет тотала четвертого периода';
const bo_v34 = (match, outcome) => 'Чет/Нечет тотала пятого периода';
const bo_w34 = (match, outcome) => 'Чет/Нечет тотала шестого периода';
const bo_x34 = (match, outcome) => 'Чет/Нечет тотала седьмого периода';
const bo_y34 = (match, outcome) => 'Точный счет матча';
const bo_z34 = (match, outcome) => `${match.awayTeam} сделает брейк в 1-м или во 2-м геймах`;
const bo_a35 = (match, outcome) => 'Максимальное количество геймов взятых подряд теннисистом';
const bo_b35 = (match, outcome) => 'Будет ли обмен брейками (два подряд)?';
const bo_c35 = (match, outcome) => `Тотал: ${match.homeTeam} в четвертом сете`;
const bo_d35 = (match, outcome) => `Тотал: ${match.homeTeam} в пятом сете`;
const bo_e35 = (match, outcome) => `Тотал: ${match.awayTeam} в четвертом сете`;
const bo_f35 = (match, outcome) => `Тотал: ${match.awayTeam} в пятом сете`;
const bo_g35 = (match, outcome) => 'Чет/Нечет четвертого сета';
const bo_h35 = (match, outcome) => 'Чет/Нечет пятого сета';
const bo_i35 = (match, outcome) => 'Первый сет/матч';
const bo_j35 = (match, outcome) => `Брейк пойнт в ${outcome.condition} гейме`;
const bo_k35 = (match, outcome) => 'Тотал брейков во втором сете';
const bo_l35 = (match, outcome) => 'Тотал брейков в третьем сете';
const bo_m35 = (match, outcome) => 'Тотал брейков в четвертом сете';
const bo_n35 = (match, outcome) => 'Тотал брейков в пятом сете';
const bo_o35 = (match, outcome) => `Победа и тотал четвертого сета ${outcome.condition}`;
const bo_p35 = (match, outcome) => `Победа и тотал пятого сета ${outcome.condition}`;
const bo_q35 = (match, outcome) => `Тотал брейков: ${match.homeTeam} в первом сете`;
const bo_r35 = (match, outcome) => `Тотал брейков: ${match.homeTeam} во втором сете`;
const bo_s35 = (match, outcome) => `Тотал брейков: ${match.homeTeam} в третьем сете`;
const bo_t35 = (match, outcome) => `Тотал брейков: ${match.homeTeam} в четвертом сете`;
const bo_u35 = (match, outcome) => `Тотал брейков: ${match.homeTeam} в пятом сете`;
const bo_v35 = (match, outcome) => `Тотал брейков: ${match.awayTeam} в первом сете`;
const bo_w35 = (match, outcome) => `Тотал брейков: ${match.awayTeam} во втором сете`;
const bo_x35 = (match, outcome) => `Тотал брейков: ${match.awayTeam} в третьем сете`;
const bo_y35 = (match, outcome) => `Тотал брейков: ${match.awayTeam} в четвертом сете`;
const bo_z35 = (match, outcome) => `Тотал брейков: ${match.awayTeam} в пятом сете`;
const bo_a36 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в первом сете?`;
const bo_b36 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} во втором сете?`;
const bo_c36 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в третьем сете?`;
const bo_d36 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в четвертом сете?`;
const bo_e36 = (match, outcome) => `Выиграет ли кто-нибудь подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в пятом сете?`;
const bo_f36 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в первом сете?`;
const bo_g36 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} во втором сете?`;
const bo_h36 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в третьем сете?`;
const bo_i36 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в четвертом сете?`;
const bo_j36 = (match, outcome) => `Выиграет ли ${match.homeTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в пятом сете?`;
const bo_k36 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в первом сете?`;
const bo_l36 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} во втором сете?`;
const bo_m36 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в третьем сете?`;
const bo_n36 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в четвертом сете?`;
const bo_o36 = (match, outcome) => `Выиграет ли ${match.awayTeam} подряд ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в пятом сете?`;
const bo_p36 = (match, outcome) => 'Фора в четвертом сете';
const bo_q36 = (match, outcome) => 'Фора в пятом сете';
const bo_r36 = (match, outcome) => 'Тотал четвертого сета';
const bo_s36 = (match, outcome) => 'Тотал пятого сета';
const bo_t36 = (match, outcome) => `Точный счет ${outcome.condition} гейма`;
const bo_u36 = (match, outcome) => `Кто возьмет ${outcome.condition} гейм?`;
const bo_v36 = (match, outcome) => 'Точный счет первого сета';
const bo_w36 = (match, outcome) => 'Точный счет второго сета';
const bo_x36 = (match, outcome) => 'Точный счет третьего сета';
const bo_y36 = (match, outcome) => 'Точный счет четвертого сета';
const bo_z36 = (match, outcome) => 'Точный счет пятого сета';
const bo_a37 = (match, outcome) => `Будет ли 15x15 в ${outcome.condition} гейме?`;
const bo_b37 = (match, outcome) => `Будет ли 30x30 в ${outcome.condition} гейме?`;
const bo_c37 = (match, outcome) => `Будет ли 40x40 в ${outcome.condition} гейме?`;
const bo_d37 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в 1ом сете`;
const bo_e37 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в 2ом сете`;
const bo_f37 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в 3ем сете`;
const bo_g37 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в 4ом сете`;
const bo_h37 = (match, outcome) => `Кто первым возьмет ${outcome.condition} ${plural(outcome.condition, ['гейм', 'гейма', 'геймов'])} в 5ом сете`;
const bo_i37 = (match, outcome) => 'Результат четвертого сета';
const bo_j37 = (match, outcome) => 'Результат пятого сета';
const bo_k37 = (match, outcome) => `Первое очко в ${outcome.condition} гейме`;
const bo_l37 = (match, outcome) => 'Будет ли тай-брейк в первом сете?';
const bo_m37 = (match, outcome) => 'Будет ли тай-брейк во втором сете?';
const bo_n37 = (match, outcome) => 'Будет ли тай-брейк в третьем сете?';
const bo_o37 = (match, outcome) => 'Будет ли тай-брейк в четвертом сете?';
const bo_p37 = (match, outcome) => 'Будет ли тай-брейк в пятом сете?';
const bo_q37 = (match, outcome) => 'Будет ли тай-брейк в матче?';
const bo_r37 = (match, outcome) => 'Тотал тай-брейка в первом сете';
const bo_s37 = (match, outcome) => 'Тотал тай-брейка во втором сете';
const bo_t37 = (match, outcome) => 'Тотал тай-брейка в третьем сете';
const bo_u37 = (match, outcome) => 'Тотал тай-брейка в четвертом сете';
const bo_v37 = (match, outcome) => 'Тотал тай-брейка в пятом сете';
const bo_w37 = (match, outcome) => 'Точный счет тай-брейка в первом сете';
const bo_x37 = (match, outcome) => 'Точный счет тай-брейка во втором сете';
const bo_y37 = (match, outcome) => 'Точный счет тай-брейка в третьем сете';
const bo_z37 = (match, outcome) => 'Точный счет тай-брейка в четвертом сете';
const bo_a38 = (match, outcome) => 'Точный счет тай-брейка в пятом сете';
const bo_b38 = (match, outcome) => 'Точный тотал тай-брейка в первом сете';
const bo_c38 = (match, outcome) => 'Точный тотал тай-брейка во втором сете';
const bo_d38 = (match, outcome) => 'Точный тотал тай-брейка в третьем сете';
const bo_e38 = (match, outcome) => 'Точный тотал тай-брейка в четвертом сете';
const bo_f38 = (match, outcome) => 'Точный тотал тай-брейка в пятом сете';
const bo_g38 = (match, outcome) => 'Кто победит в тай-брейке в первом сете?';
const bo_h38 = (match, outcome) => 'Кто победит в тай-брейке во втором сете?';
const bo_i38 = (match, outcome) => 'Кто победит в тай-брейке в третьем сете?';
const bo_j38 = (match, outcome) => 'Кто победит в тай-брейке в четвертом сете?';
const bo_k38 = (match, outcome) => 'Кто победит в тай-брейке в пятом сете?';
const bo_l38 = (match, outcome) => 'Тотал брейков в первом сете';
const bo_m38 = (match, outcome) => 'Тотал брейков в матче';
const bo_n38 = (match, outcome) => `${match.homeTeam} выиграет сет в матче`;
const bo_o38 = (match, outcome) => `${match.awayTeam} выиграет сет в матче`;
const bo_p38 = (match, outcome) => 'Тотал самого нерезультативного сета';
const bo_q38 = (match, outcome) => 'Кто подаст первый эйс в матче';
const bo_r38 = (match, outcome) => 'Кто сделает первую двойную ошибку в матче';
const bo_s38 = (match, outcome) => `${match.homeTeam}: максимальная скорость подачи (км/ч)`;
const bo_t38 = (match, outcome) => `${match.awayTeam}: максимальная скорость подачи (км/ч)`;
const bo_u38 = (match, outcome) => 'Победа в матче после проигрыша первого сета';
const bo_v38 = (match, outcome) => `${match.homeTeam}: % первой подачи`;
const bo_w38 = (match, outcome) => `${match.awayTeam}: % первой подачи`;
const bo_x38 = (match, outcome) => 'Результат по брейкам в матче';
const bo_y38 = (match, outcome) => `Тотал брейков: ${match.homeTeam}`;
const bo_z38 = (match, outcome) => `Тотал брейков: ${match.awayTeam}`;
const bo_a39 = (match, outcome) => 'Кто сделает первый брейк в матче';
const bo_b39 = (match, outcome) => `${match.homeTeam} сделает брейк в 1-м или во 2-м геймах`;
const bo_c39 = (match, outcome) => 'Будет ли в матче сет со счетом 6:0 или 0:6?';
const bo_d39 = (match, outcome) => 'Тотал эйсов в матче';
const bo_e39 = (match, outcome) => `Тотал эйсов в матче: ${match.homeTeam}`;
const bo_f39 = (match, outcome) => `Тотал эйсов в матче: ${match.awayTeam}`;
const bo_g39 = (match, outcome) => 'Тотал двойных ошибок в матче';
const bo_h39 = (match, outcome) => `Тотал двойных ошибок в матче: ${match.homeTeam}`;
const bo_i39 = (match, outcome) => `Тотал двойных ошибок в матче: ${match.awayTeam}`;
const bo_j39 = (match, outcome) => 'Результативность сетов(Тотал)';
const bo_k39 = (match, outcome) => 'Матч будет выигран подачей навылет';
const bo_l39 = (match, outcome) => `Эйс в 1-м или 2-м геймах: ${match.homeTeam}`;
const bo_m39 = (match, outcome) => `Эйс в 1-м или 2-м геймах: ${match.awayTeam}`;
const bo_n39 = (match, outcome) => `Двойная ошибка в 1-м или 2-м геймах: ${match.homeTeam}`;
const bo_o39 = (match, outcome) => `Двойная ошибка в 1-м или 2-м геймах: ${match.awayTeam}`;
const bo_p39 = (match, outcome) => 'Тотал эйсов в первом сете';
const bo_q39 = (match, outcome) => 'Спортсмен снимется (дискв.) в течение матча';
const bo_r39 = (match, outcome) => `% попадания первой подачи ${match.homeTeam}`;
const bo_s39 = (match, outcome) => `% попадания первой подачи ${match.awayTeam}`;
const bo_t39 = (match, outcome) => 'Результат по брейкам в первом сете';
const bo_u39 = (match, outcome) => 'Результат по брейкам во втором сете';
const bo_v39 = (match, outcome) => 'Результат по брейкам в третьем сете';
const bo_w39 = (match, outcome) => 'Результат по брейкам в четвертом сете';
const bo_x39 = (match, outcome) => 'Результат по брейкам в пятом сете';
const bo_y39 = (match, outcome) => 'Фора по брейкам в матче';
const bo_z39 = (match, outcome) => 'Фора по брейкам в первом сете';
const bo_a40 = (match, outcome) => 'Фора по брейкам во втором сете';
const bo_b40 = (match, outcome) => 'Фора по брейкам в третьем сете';
const bo_c40 = (match, outcome) => 'Фора по брейкам в четвертом сете';
const bo_d40 = (match, outcome) => 'Фора по брейкам в пятом сете';
const bo_e40 = (match, outcome) => `Кто возьмет ${outcome.conditionTwo} очко в ${outcome.condition} гейме`;
const bo_f40 = (match, outcome) => `Результат в ${outcome.condition} и ${outcome.conditionTwo} геймах`;
const bo_g40 = (match, outcome) => `Фора в ${outcome.conditionTwo} гейме`;
const bo_h40 = (match, outcome) => `Тотал в ${outcome.conditionTwo} гейме`;
const bo_i40 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в 4ом сете`;
const bo_j40 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} во 5ом сете`;
const bo_k40 = (match, outcome) => 'Точный тотал четвертого сета';
const bo_l40 = (match, outcome) => 'Точный тотал пятого сета';
const bo_m40 = (match, outcome) => `${match.homeTeam} победит с разницей в четвертом сете`;
const bo_n40 = (match, outcome) => `${match.homeTeam} победит с разницей в пятом сете`;
const bo_o40 = (match, outcome) => `${match.awayTeam} победит с разницей в четвертом сете`;
const bo_p40 = (match, outcome) => `${match.awayTeam} победит с разницей в пятом сете`;
const bo_q40 = (match, outcome) => 'Тотал самого результативного сета';
const bo_r40 = (match, outcome) => 'Победа с разницей в четвертом сете';
const bo_s40 = (match, outcome) => 'Победа с разницей в пятом сете';
const bo_t40 = (match, outcome) => 'Победа в минисете до 10 очков четвертого сета';
const bo_u40 = (match, outcome) => 'Фора в минисете до 10 очков четвертого сета';
const bo_v40 = (match, outcome) => 'Тотал в минисете до 10 очков четвертого сета';
const bo_w40 = (match, outcome) => 'Победа в минисете до 15 очков четвертого сета';
const bo_x40 = (match, outcome) => 'Фора в минисете до 15 очков четвертого сета';
const bo_y40 = (match, outcome) => 'Тотал в минисете до 15 очков четвертого сета';
const bo_z40 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в четвертом сете`;
const bo_a41 = (match, outcome) => `Кто выиграет ${numeralNeuterEnding(outcome.condition)} очко в пятом сете`;
const bo_b41 = (match, outcome) => 'Фора в Золотом сете';
const bo_c41 = (match, outcome) => 'Тотал Золотого сета';
const bo_d41 = (match, outcome) => `Тотал: ${match.homeTeam} в Золотом сете`;
const bo_e41 = (match, outcome) => `Тотал: ${match.awayTeam} в Золотом сете`;
const bo_f41 = (match, outcome) => 'Результат Золотого сета';
const bo_g41 = (match, outcome) => `Кто первым наберет ${outcome.condition} ${plural(outcome.condition, ['очко', 'очков', 'очков'])} в Золотом сете`;
const bo_h41 = (match, outcome) => 'Точный тотал Золотого сета';
const bo_i41 = (match, outcome) => 'Чет/Нечет Золотого сета';
const bo_j41 = (match, outcome) => `Победа и тотал Золотого сета ${outcome.condition}`;
const bo_k41 = (match, outcome) => 'Победа с разницей в Золотом сете';
const bo_l41 = (match, outcome) => 'В скольких сетах будет мини тай-брейк?';
const bo_m41 = (match, outcome) => `Кто выиграет ${outcome.condition}й раунд?`;
const bo_n41 = (match, outcome) => 'Выпадет ли 13 сектор?';
const bo_o41 = (match, outcome) => `Выпадет ли 13 сектор в ${outcome.condition}-м раунде?`;

const fa_b1 = (match, outcome) => `Ф1(${signed(outcome.condition)})`;
const fa_c1 = (match, outcome) => `Ф2(${signed(-outcome.condition)})`;
const fa_d1 = (match, outcome) => `Мен. ${outcome.condition}`;
const fa_e1 = (match, outcome) => `Бол. ${outcome.condition}`;
const fa_f1 = (match, outcome) => 'Чет';
const fa_g1 = (match, outcome) => 'Нечет';
const fa_h1 = (match, outcome) => `${match.homeTeam}`;
const fa_i1 = (match, outcome) => `${match.awayTeam}`;
const fa_j1 = (match, outcome) => '1-ая выше';
const fa_k1 = (match, outcome) => '2-ая выше';
const fa_l1 = (match, outcome) => 'Да';
const fa_m1 = (match, outcome) => 'Нет';
const fa_n1 = (match, outcome) => '0-2';
const fa_o1 = (match, outcome) => '0-3';
const fa_p1 = (match, outcome) => '1-2';
const fa_q1 = (match, outcome) => '1-3';
const fa_r1 = (match, outcome) => '2-0';
const fa_s1 = (match, outcome) => '2-1';
const fa_t1 = (match, outcome) => '2-3';
const fa_u1 = (match, outcome) => '3-0';
const fa_v1 = (match, outcome) => '3-1';
const fa_w1 = (match, outcome) => '3-2';
const fa_x1 = (match, outcome) => 'П1';
const fa_y1 = (match, outcome) => 'П2';
const fa_z1 = (match, outcome) => 'Х';
const fa_a2 = (match, outcome) => 'Никто';
const fa_b2 = (match, outcome) => '1X';
const fa_c2 = (match, outcome) => '12';
const fa_d2 = (match, outcome) => '2X';
const fa_e2 = (match, outcome) => `П1Тм ${outcome.condition}`;
const fa_f2 = (match, outcome) => `П1Тб ${outcome.condition}`;
const fa_g2 = (match, outcome) => `П2Тм ${outcome.condition}`;
const fa_h2 = (match, outcome) => `П2Тб ${outcome.condition}`;
const fa_i2 = (match, outcome) => `ХТм ${outcome.condition}`;
const fa_j2 = (match, outcome) => `ХТб ${outcome.condition}`;
const fa_k2 = (match, outcome) => '0';
const fa_l2 = (match, outcome) => '1';
const fa_m2 = (match, outcome) => '2';
const fa_n2 = (match, outcome) => '3';
const fa_o2 = (match, outcome) => '4';
const fa_p2 = (match, outcome) => '≥ 5';
const fa_q2 = (match, outcome) => 'Обе забьют';
const fa_r2 = (match, outcome) => 'Одна забьёт';
const fa_s2 = (match, outcome) => 'Обе не забьют';
const fa_t2 = (match, outcome) => '0-0';
const fa_u2 = (match, outcome) => '0-1';
const fa_v2 = (match, outcome) => '0-4';
const fa_w2 = (match, outcome) => '0-5';
const fa_x2 = (match, outcome) => '1-0';
const fa_y2 = (match, outcome) => '1-1';
const fa_z2 = (match, outcome) => '1-4';
const fa_a3 = (match, outcome) => '1-5';
const fa_b3 = (match, outcome) => '2-2';
const fa_c3 = (match, outcome) => '2-4';
const fa_d3 = (match, outcome) => '2-5';
const fa_e3 = (match, outcome) => '2-6';
const fa_f3 = (match, outcome) => '3-3';
const fa_g3 = (match, outcome) => '3-4';
const fa_h3 = (match, outcome) => '3-5';
const fa_i3 = (match, outcome) => '4-0';
const fa_j3 = (match, outcome) => '4-1';
const fa_k3 = (match, outcome) => '4-2';
const fa_l3 = (match, outcome) => '4-3';
const fa_m3 = (match, outcome) => '4-4';
const fa_n3 = (match, outcome) => '5-0';
const fa_o3 = (match, outcome) => '5-1';
const fa_p3 = (match, outcome) => '5-2';
const fa_q3 = (match, outcome) => '5-3';
const fa_r3 = (match, outcome) => 'Любой другой';
const fa_s3 = (match, outcome) => `≤ ${outcome.condition}`;
const fa_t3 = (match, outcome) => `${outcome.condition + 1} - ${outcome.condition + 2}`;
const fa_u3 = (match, outcome) => `${outcome.condition + 3} - ${outcome.condition + 4}`;
const fa_v3 = (match, outcome) => `${outcome.condition + 5} - ${outcome.condition + 6}`;
const fa_w3 = (match, outcome) => `${outcome.condition + 7} - ${outcome.condition + 8}`;
const fa_x3 = (match, outcome) => `≥ ${outcome.condition + 9}`;
const fa_y3 = (match, outcome) => '6-9';
const fa_z3 = (match, outcome) => '10-12';
const fa_a4 = (match, outcome) => '13-16';
const fa_b4 = (match, outcome) => '17-20';
const fa_c4 = (match, outcome) => '≥21';
const fa_d4 = (match, outcome) => `Проход: ${match.homeTeam}`;
const fa_e4 = (match, outcome) => `Проход: ${match.awayTeam}`;
const fa_f4 = (match, outcome) => '1-ая половина';
const fa_g4 = (match, outcome) => '2-ая половина';
const fa_h4 = (match, outcome) => '1-ая четверть';
const fa_i4 = (match, outcome) => '2-ая четверть';
const fa_j4 = (match, outcome) => '3-ая четверть';
const fa_k4 = (match, outcome) => '4-ая четверть';
const fa_l4 = (match, outcome) => 'П1: 1-2';
const fa_m4 = (match, outcome) => 'П1: 3-5';
const fa_n4 = (match, outcome) => 'П1: 6-9';
const fa_o4 = (match, outcome) => 'П1: 10-12';
const fa_p4 = (match, outcome) => 'П1: 13-16';
const fa_q4 = (match, outcome) => 'П1: 17-20';
const fa_r4 = (match, outcome) => 'П1: ≥21';
const fa_s4 = (match, outcome) => 'П2: 1-2';
const fa_t4 = (match, outcome) => 'П2: 3-5';
const fa_u4 = (match, outcome) => 'П2: 6-9';
const fa_v4 = (match, outcome) => 'П2: 10-12';
const fa_w4 = (match, outcome) => 'П2: 13-16';
const fa_x4 = (match, outcome) => 'П2: 17-20';
const fa_y4 = (match, outcome) => 'П2: ≥21';
const fa_z4 = (match, outcome) => 'П1: 3-4';
const fa_a5 = (match, outcome) => 'П1: 5-7';
const fa_b5 = (match, outcome) => 'П1: ≥8';
const fa_c5 = (match, outcome) => 'Х2';
const fa_d5 = (match, outcome) => 'П2: 3-4';
const fa_e5 = (match, outcome) => 'П2: 5-7';
const fa_f5 = (match, outcome) => 'П2: ≥8';
const fa_g5 = (match, outcome) => 'Х1';
const fa_h5 = (match, outcome) => 'Штрафной';
const fa_i5 = (match, outcome) => '3-очковый';
const fa_j5 = (match, outcome) => '2-очковый';
const fa_k5 = (match, outcome) => `П1 ≥ ${outcome.condition}`;
const fa_l5 = (match, outcome) => `Разница меньше ${outcome.condition}`;
const fa_m5 = (match, outcome) => `П2 ≥ ${outcome.condition}`;
const fa_n5 = (match, outcome) => `П1: Бол. ${outcome.condition}=21`;
const fa_o5 = (match, outcome) => `П2: Бол. ${outcome.condition}=21`;
const fa_p5 = (match, outcome) => 'П1: 8 и более';
const fa_q5 = (match, outcome) => 'П2: 8 и более';
const fa_r5 = (match, outcome) => 'Никакая';
const fa_s5 = (match, outcome) => 'П1: 1';
const fa_t5 = (match, outcome) => 'П1: 2';
const fa_u5 = (match, outcome) => 'П1: 3';
const fa_v5 = (match, outcome) => 'П1: 4';
const fa_w5 = (match, outcome) => 'П1: ≥ 5';
const fa_x5 = (match, outcome) => 'П2: 1';
const fa_y5 = (match, outcome) => 'П2: 2';
const fa_z5 = (match, outcome) => 'П2: 3';
const fa_a6 = (match, outcome) => 'П2: 4';
const fa_b6 = (match, outcome) => 'П2: ≥ 5';
const fa_c6 = (match, outcome) => '1Х';
const fa_d6 = (match, outcome) => 'Обе';
const fa_e6 = (match, outcome) => 'Одна';
const fa_f6 = (match, outcome) => 'Ни одна';
const fa_g6 = (match, outcome) => '0 или 1';
const fa_h6 = (match, outcome) => '5';
const fa_i6 = (match, outcome) => '6';
const fa_j6 = (match, outcome) => '7';
const fa_k6 = (match, outcome) => '≥ 8';
const fa_l6 = (match, outcome) => 'П1П1';
const fa_m6 = (match, outcome) => 'П1Н';
const fa_n6 = (match, outcome) => 'П1П2';
const fa_o6 = (match, outcome) => 'НП1';
const fa_p6 = (match, outcome) => 'НН';
const fa_q6 = (match, outcome) => 'НП2';
const fa_r6 = (match, outcome) => 'П2П1';
const fa_s6 = (match, outcome) => 'П2Н';
const fa_t6 = (match, outcome) => 'П2П2';
const fa_u6 = (match, outcome) => `${outcome.condition + 1}`;
const fa_v6 = (match, outcome) => `${outcome.condition + 2}`;
const fa_w6 = (match, outcome) => `${outcome.condition + 3}`;
const fa_x6 = (match, outcome) => `${outcome.condition + 4}`;
const fa_y6 = (match, outcome) => `${outcome.condition + 5}`;
const fa_z6 = (match, outcome) => `${outcome.condition + 6}`;
const fa_a7 = (match, outcome) => `≥ ${outcome.condition + 7}`;
const fa_b7 = (match, outcome) => `от ${outcome.condition + 1} до ${outcome.condition + 2}`;
const fa_c7 = (match, outcome) => `от ${outcome.condition + 3} до ${outcome.condition + 4}`;
const fa_d7 = (match, outcome) => `от ${outcome.condition + 5} до ${outcome.condition + 6}`;
const fa_e7 = (match, outcome) => '4-6';
const fa_f7 = (match, outcome) => '7 и более';
const fa_g7 = (match, outcome) => 'П1Тм';
const fa_h7 = (match, outcome) => 'П1Тб';
const fa_i7 = (match, outcome) => 'П2Тм';
const fa_j7 = (match, outcome) => 'П2Тб';
const fa_k7 = (match, outcome) => 'П1: 2-3';
const fa_l7 = (match, outcome) => 'П1: 4-6';
const fa_m7 = (match, outcome) => 'П1: ≥7';
const fa_n7 = (match, outcome) => 'П2: 2-3';
const fa_o7 = (match, outcome) => 'П2: 4-6';
const fa_p7 = (match, outcome) => 'П2: ≥7';
const fa_q7 = (match, outcome) => `${outcome.condition}`;
const fa_r7 = (match, outcome) => `≥ ${outcome.condition + 6}`;
const fa_s7 = (match, outcome) => 'П1: досрочная победа';
const fa_t7 = (match, outcome) => 'П1: победа по очкам';
const fa_u7 = (match, outcome) => 'Ничья';
const fa_v7 = (match, outcome) => 'П2: досрочная победа';
const fa_w7 = (match, outcome) => 'П2: победа по очкам';
const fa_x7 = (match, outcome) => 'П1: 1 раунд';
const fa_y7 = (match, outcome) => 'П1: 2 раунд';
const fa_z7 = (match, outcome) => 'П1: 3 раунд';
const fa_a8 = (match, outcome) => 'П1: 4 раунд';
const fa_b8 = (match, outcome) => 'П1: 5 раунд';
const fa_c8 = (match, outcome) => 'П1: 6 раунд';
const fa_d8 = (match, outcome) => 'П1: 7 раунд';
const fa_e8 = (match, outcome) => 'П1: 8 раунд';
const fa_f8 = (match, outcome) => 'П1: 9 раунд';
const fa_g8 = (match, outcome) => 'П1: 10 раунд';
const fa_h8 = (match, outcome) => 'П1: 11 раунд';
const fa_i8 = (match, outcome) => 'П1: 12 раунд';
const fa_j8 = (match, outcome) => 'П2: 1 раунд';
const fa_k8 = (match, outcome) => 'П2: 2 раунд';
const fa_l8 = (match, outcome) => 'П2: 3 раунд';
const fa_m8 = (match, outcome) => 'П2: 4 раунд';
const fa_n8 = (match, outcome) => 'П2: 5 раунд';
const fa_o8 = (match, outcome) => 'П2: 6 раунд';
const fa_p8 = (match, outcome) => 'П2: 7 раунд';
const fa_q8 = (match, outcome) => 'П2: 8 раунд';
const fa_r8 = (match, outcome) => 'П2: 9 раунд';
const fa_s8 = (match, outcome) => 'П2: 10 раунд';
const fa_t8 = (match, outcome) => 'П2: 11 раунд';
const fa_u8 = (match, outcome) => 'П2: 12 раунд';
const fa_v8 = (match, outcome) => 'X';
const fa_w8 = (match, outcome) => '5 и более';
const fa_x8 = (match, outcome) => 'Ни одной';
const fa_y8 = (match, outcome) => `Каждая из команд забьёт ${outcome.condition + 1} или более голов`;
const fa_z8 = (match, outcome) => `Ровно одна забьёт ${outcome.condition + 1} или более голов`;
const fa_a9 = (match, outcome) => `Никто не забьёт ${outcome.condition + 1} или более голов`;
const fa_b9 = (match, outcome) => 'Головой';
const fa_c9 = (match, outcome) => 'Ногой(с игры)';
const fa_d9 = (match, outcome) => 'Автоголом';
const fa_e9 = (match, outcome) => 'С пенальти';
const fa_f9 = (match, outcome) => 'Угловой';
const fa_g9 = (match, outcome) => 'Офсайд';
const fa_h9 = (match, outcome) => 'ЖК';
const fa_i9 = (match, outcome) => 'Гол';
const fa_j9 = (match, outcome) => 'Будет';
const fa_k9 = (match, outcome) => 'Не будет';
const fa_l9 = (match, outcome) => `Раньше ${outcome.condition}`;
const fa_m9 = (match, outcome) => `Позже ${outcome.condition}`;
const fa_n9 = (match, outcome) => 'В первом тайме';
const fa_o9 = (match, outcome) => 'Во втором тайме';
const fa_p9 = (match, outcome) => 'Гола не будет';
const fa_q9 = (match, outcome) => 'Не забьет';
const fa_r9 = (match, outcome) => '0-6';
const fa_s9 = (match, outcome) => '1-6';
const fa_t9 = (match, outcome) => '6-0';
const fa_u9 = (match, outcome) => '6-1';
const fa_v9 = (match, outcome) => 'Голевая ничья';
const fa_w9 = (match, outcome) => 'Безголевая ничья';
const fa_x9 = (match, outcome) => 'Не ничья';
const fa_y9 = (match, outcome) => 'Забьет';
const fa_z9 = (match, outcome) => 'Первый меньше';
const fa_a10 = (match, outcome) => 'Равенство';
const fa_b10 = (match, outcome) => 'Первый больше';
const fa_c10 = (match, outcome) => 'Да/Да';
const fa_d10 = (match, outcome) => 'Да/Нет';
const fa_e10 = (match, outcome) => 'Нет/Да';
const fa_f10 = (match, outcome) => 'Нет/Нет';
const fa_g10 = (match, outcome) => `Тб${outcome.condition}/Да`;
const fa_h10 = (match, outcome) => `Тб${outcome.condition}/Нет`;
const fa_i10 = (match, outcome) => `Тм${outcome.condition}/Да`;
const fa_j10 = (match, outcome) => `Тм${outcome.condition}/Нет`;
const fa_k10 = (match, outcome) => 'П1 в основное время';
const fa_l10 = (match, outcome) => 'П2 в основное время';
const fa_m10 = (match, outcome) => 'П1 в доп. время';
const fa_n10 = (match, outcome) => 'П2 в доп. время';
const fa_o10 = (match, outcome) => 'П1 в серии пенальти';
const fa_p10 = (match, outcome) => 'П2 в серии пенальти';
const fa_q10 = (match, outcome) => '1 тайм';
const fa_r10 = (match, outcome) => 'Перерыв';
const fa_s10 = (match, outcome) => '2 тайм';
const fa_t10 = (match, outcome) => '5-4';
const fa_u10 = (match, outcome) => 'П1 с любым другим';
const fa_v10 = (match, outcome) => '4-5';
const fa_w10 = (match, outcome) => 'П2 с любым другим';
const fa_x10 = (match, outcome) => '1-10';
const fa_y10 = (match, outcome) => '11-20';
const fa_z10 = (match, outcome) => '21-30';
const fa_a11 = (match, outcome) => '31-40';
const fa_b11 = (match, outcome) => '41-50';
const fa_c11 = (match, outcome) => '51-60';
const fa_d11 = (match, outcome) => '61-70';
const fa_e11 = (match, outcome) => '71-80';
const fa_f11 = (match, outcome) => '81-конец ОВ';
const fa_g11 = (match, outcome) => 'Нет гола';
const fa_h11 = (match, outcome) => 'X2';
const fa_i11 = (match, outcome) => '1<2';
const fa_j11 = (match, outcome) => '1=2';
const fa_k11 = (match, outcome) => '1>2';
const fa_l11 = (match, outcome) => '1<3';
const fa_m11 = (match, outcome) => '1=3';
const fa_n11 = (match, outcome) => '1>3';
const fa_o11 = (match, outcome) => '2<3';
const fa_p11 = (match, outcome) => '2=3';
const fa_q11 = (match, outcome) => '2>3';
const fa_r11 = (match, outcome) => 'да';
const fa_s11 = (match, outcome) => 'нет';
const fa_t11 = (match, outcome) => 'Желтый шар';
const fa_u11 = (match, outcome) => 'Зеленый шар';
const fa_v11 = (match, outcome) => 'Коричневый шар';
const fa_w11 = (match, outcome) => 'Голубой шар';
const fa_x11 = (match, outcome) => 'Розовый шар';
const fa_y11 = (match, outcome) => 'Черный шар';
const fa_z11 = (match, outcome) => `≥ ${outcome.condition + 5}`;
const fa_a12 = (match, outcome) => '≤ 14';
const fa_b12 = (match, outcome) => 'от 15 до 17';
const fa_c12 = (match, outcome) => 'от 18 до 19';
const fa_d12 = (match, outcome) => '≥ 20';
const fa_e12 = (match, outcome) => 'П1-0';
const fa_f12 = (match, outcome) => 'П1-15';
const fa_g12 = (match, outcome) => 'П1-30';
const fa_h12 = (match, outcome) => 'П1-40';
const fa_i12 = (match, outcome) => '0-П2';
const fa_j12 = (match, outcome) => '15-П2';
const fa_k12 = (match, outcome) => '30-П2';
const fa_l12 = (match, outcome) => '40-П2';
const fa_m12 = (match, outcome) => '3-6';
const fa_n12 = (match, outcome) => '5-7';
const fa_o12 = (match, outcome) => '6-2';
const fa_p12 = (match, outcome) => '6-3';
const fa_q12 = (match, outcome) => '6-4';
const fa_r12 = (match, outcome) => '6-7';
const fa_s12 = (match, outcome) => '7-5';
const fa_t12 = (match, outcome) => '7-6';
const fa_u12 = (match, outcome) => '7-0';
const fa_v12 = (match, outcome) => '7-1';
const fa_w12 = (match, outcome) => '7-2';
const fa_x12 = (match, outcome) => '7-3';
const fa_y12 = (match, outcome) => '7-4';
const fa_z12 = (match, outcome) => '0-7';
const fa_a13 = (match, outcome) => '1-7';
const fa_b13 = (match, outcome) => '2-7';
const fa_c13 = (match, outcome) => '3-7';
const fa_d13 = (match, outcome) => '4-7';
const fa_e13 = (match, outcome) => '8';
const fa_f13 = (match, outcome) => '9';
const fa_g13 = (match, outcome) => '10';
const fa_h13 = (match, outcome) => '11';
const fa_i13 = (match, outcome) => '≥ 13';
const fa_j13 = (match, outcome) => `${match.homeTeam} (С.П.)`;
const fa_k13 = (match, outcome) => `${match.awayTeam} (С.П.)`;
const fa_l13 = (match, outcome) => 'Оба П1';
const fa_m13 = (match, outcome) => 'Оба П2';
const fa_n13 = (match, outcome) => 'Ф1';
const fa_o13 = (match, outcome) => 'Ф2';
const fa_p13 = (match, outcome) => 'П1: 7 и более';
const fa_q13 = (match, outcome) => 'П2: 7 и более';
const fa_r13 = (match, outcome) => '6-5';
const fa_s13 = (match, outcome) => '5-6';

let groupConfig = {
    32: {
        0: 'Матч',
        1: 'Первый сет',
        2: 'Второй сет',
        3: 'Третий сет',
        4: 'Мини-сет до 10 очков (Первый сет)',
        5: 'Мини-сет до 15 очков (Первый сет)',
        6: 'Мини-сет до 10 очков (Второй сет)',
        7: 'Мини-сет до 15 очков (Второй сет)',
        8: 'Мини-сет до 10 очков (Третий сет)',
        9: 'Мини-сет до 15 очков (Третий сет)'
    },
    35: {
        0: 'Матч',
        1: 'Первый период'
    },
    31: {
        0: 'Матч',
        1: 'Первая четверть',
        2: 'Вторая четверть',
        3: 'Третья четверть',
        4: 'Четвертая четверть',
        5: 'Двухочковые броски',
        6: 'Трехочковые броски',
        7: 'Первая половина',
        8: 'Вторая половина'
    },
    41: {
        0: 'Матч',
        1: 'Первая половина',
        2: 'Вторая половина',
        3: 'Двухочковые броски',
        4: 'Трехочковые броски'
    },
    18: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период',
        3: 'Третий период'
    },
    3: {
        0: 'Матч',
        1: 'Первый сет',
        2: 'Второй сет',
        3: 'Третий сет',
        4: 'Мини-сет до 10 очков (Первый сет)',
        5: 'Мини-сет до 15 очков (Первый сет)',
        6: 'Мини-сет до 10 очков (Второй сет)',
        7: 'Мини-сет до 15 очков (Второй сет)'
    },
    20: {
        0: 'Матч',
        1: 'Первый огневой рубеж',
        2: 'Второй огневой рубеж',
        3: 'Третий огневой рубеж',
        4: 'Четвертый огневой рубеж',
        5: 'Пятый огневой рубеж',
        6: 'Шестой огневой рубеж',
        7: 'Седьмой огневой рубеж',
        8: 'Восьмой огневой рубеж'
    },
    42: {
        0: 'Матч',
        1: 'Первая карта',
        2: 'Вторая карта',
        3: 'Третья карта',
        4: 'Четвертая карта',
        5: 'Пятая карта'
    },
    36: {
        0: 'Матч',
        1: 'Первый период'
    },
    7: {
        0: 'Матч',
        1: 'Первый тайм',
        2: 'Второй тайм',
        3: 'С 1 по 15 минуту',
        4: 'С 16 по 30 минуту',
        5: 'С 31 минуты до перерыва',
        6: 'С 46 по 60 минуту',
        7: 'С 61 по 75 минуту',
        8: 'С 76 минуты до конца ОВ',
        9: 'Угловые',
        10: 'Угловые (Первый тайм)',
        11: 'Желтые карточки',
        12: 'Желтые карточки (Первый тайм)',
        13: 'Доп. время',
        14: 'Первое доп. время',
        15: 'Второе доп. время',
        16: 'Серия пенальти'
    },
    34: {
        0: 'Матч',
        1: 'Первый тайм',
        2: 'Второй тайм',
        3: 'С 1 по 15 минуту',
        4: 'С 16 по 30 минуту',
        5: 'С 31 минуты до перерыва',
        6: 'С 46 по 60 минуту',
        7: 'С 61 по 75 минуту',
        8: 'С 76 минуты до конца ОВ',
        9: 'Угловые',
        10: 'Желтые карточки'
    },
    19: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период'
    },
    30: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период',
        3: 'Третий период',
        4: 'С 1 по 10 минуту',
        5: 'С 11 по 20 минуту',
        6: 'С 21 по 30 минуту',
        7: 'С 31 по 40 минуту',
        8: 'С 41 по 50 минуту',
        9: 'С 51 по 60 минуту'
    },
    9: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период'
    },
    29: {
        0: 'Матч',
        1: 'Первый период',
        2: 'Второй период',
        3: 'Третий период',
        4: 'Четвертый период',
        5: 'Пятый период',
        6: 'Шестой период',
        7: 'Седьмой период',
        8: 'Восьмой период',
        9: 'Девятый период',
        10: 'Десятый период',
        11: 'Одинадцатый период',
        12: 'Двенадцатый период',
        13: 'Тринадцатый период',
        14: 'Четырнадцатый период',
        15: 'Пятнадцатый период',
        16: 'Шестнадцатый период',
        17: 'Семнадцатый период',
        18: 'Восемнадцатый период',
        19: 'Девятнадцатый период',
        20: 'Двадцатый период',
        21: 'Двадцать первый период',
        22: 'Двадцать второй период',
        23: 'Двадцать третий период',
        24: 'Двадцать четвертый период',
        25: 'Двадцать пятый период',
        26: 'Двадцать шестой период',
        27: 'Двадцать седьмой период',
        28: 'Двадцать восьмой период',
        29: 'Двадцать девятый период',
        30: 'Тридцатый период',
        31: 'Тридцать первый период',
        32: 'Тридцать второй период',
        33: 'Тридцать третий период',
        34: 'Тридцать четвертый период',
        35: 'Тридцать пятый период',
        36: 'Тридцать шестой период',
        37: 'Тридцать седьмой период'
    },
    2: {
        0: 'Матч',
        1: 'Первый сет',
        2: 'Второй сет',
        3: 'Третий сет',
        4: 'Четвертый сет',
        5: 'Пятый сет',
        6: 'Шестой сет',
        7: 'Седьмой сет'
    },
    6: {
        0: 'Матч',
        1: 'Первый сет',
        2: 'Второй сет',
        3: 'Третий сет',
        4: 'Четвертый сет',
        5: 'Пятый сет'
    },
    4: {
        0: 'Матч',
        1: 'Первый сет',
        2: 'Второй сет',
        3: 'Третий сет',
        4: 'Четвертый сет',
        5: 'Пятый сет',
        6: 'Шестой сет',
        7: 'Мини-сет до 10 очков (Первый сет)',
        8: 'Мини-сет до 15 очков (Первый сет)',
        9: 'Мини-сет до 10 очков (Второй сет)',
        10: 'Мини-сет до 15 очков (Второй сет)',
        11: 'Мини-сет до 10 очков (Третий сет)',
        12: 'Мини-сет до 15 очков (Третий сет)',
        13: 'Мини-сет до 10 очков (Четвертый сет)',
        14: 'Мини-сет до 15 очков (Четвертый сет)'
    },
    8: {
        0: 'Матч',
        1: 'Первая четверть',
        2: 'Вторая четверть',
        3: 'Третья четверть',
        4: 'Четвертая четверть'
    }
};

let slotConfig = {
    32: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        557: sl_e1,
        607: sl_f1,
        122: sl_g1,
        129: sl_h1,
        138: sl_i1,
        182: sl_j1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        558: sl_e1,
        608: sl_f1,
        123: sl_g1,
        130: sl_h1,
        139: sl_i1,
        183: sl_j1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        559: sl_e1,
        609: sl_f1,
        124: sl_g1,
        131: sl_h1,
        140: sl_i1,
        184: sl_j1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1,
        364: sl_k1,
        19: sl_c1,
        178: sl_d1,
        360: sl_k1,
        15: sl_c1,
        174: sl_d1
    },
    35: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1
    },
    31: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        769: sl_l1,
        138: sl_i1,
        182: sl_j1,
        775: sl_m1,
        765: sl_n1,
        629: sl_e1,
        633: sl_o1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        770: sl_l1,
        139: sl_i1,
        183: sl_j1,
        776: sl_m1,
        766: sl_n1,
        630: sl_e1,
        634: sl_o1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        771: sl_l1,
        140: sl_p1,
        184: sl_q1,
        777: sl_m1,
        767: sl_n1,
        631: sl_r1,
        635: sl_o1,
        667: sl_b1,
        24: sl_c1,
        198: sl_d1,
        772: sl_l1,
        141: sl_p1,
        185: sl_q1,
        778: sl_m1,
        768: sl_n1,
        632: sl_r1,
        636: sl_o1,
        676: sl_b1,
        248: sl_d1,
        62: sl_c1,
        241: sl_p1,
        233: sl_q1,
        406: sl_s1,
        675: sl_b1,
        246: sl_d1,
        61: sl_c1,
        240: sl_p1,
        232: sl_q1,
        405: sl_s1,
        672: sl_b1,
        58: sl_c1,
        238: sl_d1,
        234: sl_p1,
        236: sl_q1,
        673: sl_b1,
        59: sl_c1,
        239: sl_d1,
        235: sl_p1,
        237: sl_q1
    },
    41: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        782: sl_l1,
        785: sl_m1,
        780: sl_n1,
        138: sl_p1,
        182: sl_q1,
        639: sl_r1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        783: sl_l1,
        786: sl_t1,
        781: sl_t1,
        139: sl_p1,
        183: sl_q1,
        640: sl_r1,
        64: sl_c1,
        678: sl_b1,
        250: sl_d1,
        63: sl_c1,
        677: sl_b1,
        249: sl_d1
    },
    18: {
        664: sl_b1,
        195: sl_d1,
        698: sl_u1,
        21: sl_c1,
        734: sl_v1,
        665: sl_b1,
        196: sl_d1,
        699: sl_u1,
        22: sl_c1,
        735: sl_v1,
        666: sl_b1,
        197: sl_d1,
        700: sl_u1,
        23: sl_c1,
        736: sl_v1
    },
    3: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        896: sl_w1,
        138: sl_i1,
        182: sl_j1,
        557: sl_x1,
        83: sl_y1,
        788: sl_z1,
        842: sl_a2,
        845: sl_b2,
        848: sl_c2,
        607: sl_f1,
        791: sl_t1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        897: sl_w1,
        139: sl_i1,
        183: sl_j1,
        558: sl_x1,
        84: sl_y1,
        789: sl_z1,
        843: sl_a2,
        846: sl_b2,
        849: sl_c2,
        608: sl_f1,
        792: sl_t1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        898: sl_w1,
        140: sl_i1,
        184: sl_j1,
        559: sl_x1,
        85: sl_y1,
        790: sl_z1,
        844: sl_a2,
        847: sl_b2,
        850: sl_c2,
        609: sl_f1,
        793: sl_t1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1
    },
    20: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        851: sl_l1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        852: sl_l1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        853: sl_l1,
        667: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        854: sl_l1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        25: sl_c1,
        668: sl_b1,
        855: sl_l1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        26: sl_c1,
        669: sl_b1,
        856: sl_l1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        27: sl_c1,
        670: sl_b1,
        857: sl_l1,
        202: sl_d1,
        145: sl_i1,
        189: sl_j1,
        28: sl_c1,
        671: sl_b1,
        858: sl_l1
    },
    42: {
        557: sl_d2,
        1865: sl_e2,
        558: sl_d2,
        1866: sl_e2,
        559: sl_d2,
        1867: sl_e2,
        560: sl_d2,
        1868: sl_e2,
        561: sl_d2,
        1869: sl_e2
    },
    36: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1
    },
    7: {
        426: sl_z1,
        526: sl_a2,
        419: sl_f2,
        519: sl_g2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_v1,
        756: sl_l1,
        698: sl_h2,
        794: sl_i2,
        860: sl_j2,
        273: sl_k2,
        83: sl_y1,
        727: sl_l2,
        729: sl_m2,
        731: sl_n2,
        648: sl_o2,
        420: sl_f2,
        520: sl_g2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_v1,
        757: sl_l1,
        699: sl_h2,
        859: sl_i2,
        861: sl_j2,
        274: sl_k2,
        84: sl_y1,
        728: sl_l2,
        649: sl_o2,
        652: sl_b1,
        641: sl_o2,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        642: sl_o2,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        643: sl_o2,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        644: sl_o2,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        645: sl_o2,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        646: sl_o2,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        680: sl_b1,
        66: sl_c1,
        255: sl_d1,
        438: sl_p2,
        354: sl_i1,
        355: sl_j1,
        681: sl_b1,
        67: sl_c1,
        258: sl_d1,
        356: sl_i1,
        357: sl_j1,
        690: sl_q2,
        81: sl_c1,
        353: sl_d1,
        440: sl_r2,
        441: sl_s2,
        682: sl_b1,
        68: sl_c1,
        259: sl_d1,
        146: sl_i1,
        650: sl_o2,
        740: sl_v1,
        69: sl_c1,
        262: sl_d1,
        683: sl_b1,
        694: sl_m2,
        180: sl_q1,
        70: sl_c1,
        263: sl_d1,
        684: sl_b1,
        72: sl_c1,
        277: sl_d1,
        686: sl_b1,
        181: sl_t2,
        147: sl_u2,
        741: sl_v1,
        276: sl_v2,
        275: sl_w2
    },
    34: {
        419: sl_f2,
        519: sl_g2,
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        734: sl_v1,
        756: sl_l1,
        698: sl_h2,
        794: sl_i2,
        860: sl_j2,
        83: sl_y1,
        420: sl_f2,
        520: sl_g2,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        735: sl_v1,
        757: sl_l1,
        699: sl_h2,
        795: sl_i2,
        861: sl_j2,
        84: sl_y1,
        652: sl_b1,
        2: sl_c1,
        160: sl_d1,
        148: sl_i1,
        154: sl_j1,
        655: sl_b1,
        5: sl_c1,
        163: sl_d1,
        149: sl_i1,
        155: sl_j1,
        657: sl_b1,
        7: sl_c1,
        165: sl_d1,
        150: sl_i1,
        156: sl_j1,
        658: sl_b1,
        930: sl_c1,
        166: sl_d1,
        151: sl_i1,
        157: sl_j1,
        660: sl_b1,
        9: sl_c1,
        168: sl_d1,
        152: sl_i1,
        158: sl_j1,
        663: sl_b1,
        12: sl_c1,
        171: sl_d1,
        153: sl_i1,
        159: sl_j1,
        255: sl_d1,
        353: sl_d1
    },
    19: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        877: sl_l1,
        138: sl_i1,
        182: sl_j1,
        875: sl_x2,
        873: sl_y2,
        196: sl_d1,
        878: sl_l1,
        876: sl_x2,
        874: sl_y2,
        665: sl_b1,
        22: sl_c1
    },
    30: {
        664: sl_b1,
        21: sl_c1,
        195: sl_d1,
        756: sl_l1,
        138: sl_i1,
        182: sl_j1,
        734: sl_v1,
        83: sl_y1,
        698: sl_u1,
        665: sl_b1,
        22: sl_c1,
        196: sl_d1,
        757: sl_l1,
        139: sl_i1,
        183: sl_j1,
        735: sl_v1,
        84: sl_y1,
        699: sl_u1,
        666: sl_b1,
        23: sl_c1,
        197: sl_d1,
        758: sl_l1,
        140: sl_i1,
        184: sl_j1,
        736: sl_v1,
        85: sl_y1,
        700: sl_u1,
        653: sl_b1,
        161: sl_d1,
        3: sl_c1,
        654: sl_b1,
        162: sl_d1,
        4: sl_c1,
        656: sl_b1,
        164: sl_d1,
        6: sl_c1,
        659: sl_b1,
        167: sl_d1,
        8: sl_c1,
        661: sl_b1,
        169: sl_d1,
        10: sl_c1,
        662: sl_b1,
        170: sl_d1,
        11: sl_c1
    },
    9: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1
    },
    29: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        466: sl_z2,
        557: sl_e1,
        799: sl_a3,
        83: sl_y1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        467: sl_z2,
        558: sl_e1,
        800: sl_a3,
        84: sl_y1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        468: sl_z2,
        559: sl_e1,
        801: sl_a3,
        85: sl_y1,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        469: sl_z2,
        560: sl_e1,
        802: sl_a3,
        86: sl_y1,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        470: sl_z2,
        561: sl_e1,
        803: sl_a3,
        87: sl_y1,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        471: sl_z2,
        562: sl_e1,
        804: sl_a3,
        88: sl_y1,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        472: sl_z2,
        563: sl_e1,
        805: sl_a3,
        89: sl_y1,
        373: sl_b1,
        28: sl_c1,
        202: sl_d1,
        473: sl_z2,
        564: sl_e1,
        806: sl_a3,
        90: sl_y1,
        374: sl_b1,
        29: sl_c1,
        203: sl_d1,
        474: sl_z2,
        565: sl_e1,
        807: sl_a3,
        91: sl_y1,
        375: sl_b1,
        30: sl_c1,
        204: sl_d1,
        475: sl_z2,
        566: sl_e1,
        808: sl_a3,
        92: sl_y1,
        376: sl_b1,
        31: sl_c1,
        205: sl_d1,
        476: sl_z2,
        567: sl_e1,
        809: sl_a3,
        93: sl_y1,
        377: sl_b1,
        32: sl_c1,
        206: sl_d1,
        477: sl_z2,
        568: sl_e1,
        810: sl_a3,
        94: sl_y1,
        378: sl_b1,
        33: sl_c1,
        207: sl_d1,
        478: sl_z2,
        569: sl_e1,
        811: sl_a3,
        95: sl_y1,
        379: sl_b1,
        34: sl_c1,
        208: sl_d1,
        479: sl_z2,
        570: sl_e1,
        812: sl_a3,
        96: sl_y1,
        380: sl_b1,
        35: sl_c1,
        209: sl_d1,
        480: sl_z2,
        571: sl_e1,
        813: sl_a3,
        97: sl_y1,
        381: sl_b1,
        36: sl_c1,
        210: sl_d1,
        481: sl_z2,
        572: sl_e1,
        814: sl_a3,
        98: sl_y1,
        382: sl_b1,
        37: sl_c1,
        211: sl_d1,
        482: sl_z2,
        573: sl_e1,
        815: sl_a3,
        99: sl_y1,
        383: sl_b1,
        38: sl_c1,
        212: sl_d1,
        483: sl_z2,
        574: sl_e1,
        816: sl_a3,
        100: sl_y1,
        384: sl_b1,
        39: sl_c1,
        213: sl_d1,
        484: sl_z2,
        575: sl_e1,
        817: sl_a3,
        101: sl_y1,
        385: sl_b1,
        40: sl_c1,
        214: sl_d1,
        485: sl_z2,
        576: sl_e1,
        818: sl_a3,
        104: sl_y1,
        386: sl_b1,
        41: sl_c1,
        215: sl_d1,
        486: sl_z2,
        577: sl_e1,
        819: sl_a3,
        105: sl_y1,
        387: sl_b1,
        42: sl_c1,
        216: sl_d1,
        487: sl_z2,
        578: sl_e1,
        820: sl_a3,
        106: sl_y1,
        388: sl_b1,
        43: sl_c1,
        217: sl_d1,
        488: sl_z2,
        579: sl_e1,
        821: sl_a3,
        107: sl_y1,
        389: sl_b1,
        44: sl_c1,
        218: sl_d1,
        489: sl_z2,
        580: sl_e1,
        822: sl_a3,
        108: sl_y1,
        390: sl_b1,
        45: sl_c1,
        219: sl_d1,
        490: sl_z2,
        581: sl_e1,
        823: sl_a3,
        109: sl_y1,
        391: sl_b1,
        46: sl_c1,
        220: sl_d1,
        491: sl_z2,
        582: sl_e1,
        824: sl_a3,
        110: sl_y1,
        392: sl_b1,
        47: sl_c1,
        221: sl_d1,
        492: sl_z2,
        583: sl_e1,
        825: sl_a3,
        111: sl_y1,
        393: sl_b1,
        48: sl_c1,
        222: sl_d1,
        493: sl_z2,
        584: sl_e1,
        826: sl_a3,
        112: sl_y1,
        394: sl_b1,
        49: sl_c1,
        223: sl_d1,
        494: sl_z2,
        585: sl_e1,
        827: sl_a3,
        113: sl_y1,
        395: sl_b1,
        50: sl_c1,
        224: sl_d1,
        495: sl_z2,
        586: sl_e1,
        828: sl_a3,
        114: sl_y1,
        396: sl_b1,
        51: sl_c1,
        225: sl_d1,
        496: sl_z2,
        587: sl_e1,
        829: sl_a3,
        115: sl_y1,
        397: sl_b1,
        52: sl_c1,
        226: sl_d1,
        497: sl_z2,
        588: sl_e1,
        830: sl_a3,
        116: sl_y1,
        398: sl_b1,
        53: sl_c1,
        227: sl_d1,
        498: sl_z2,
        589: sl_e1,
        831: sl_a3,
        117: sl_y1,
        399: sl_b1,
        54: sl_c1,
        228: sl_d1,
        499: sl_z2,
        590: sl_e1,
        832: sl_a3,
        118: sl_y1,
        400: sl_b1,
        55: sl_c1,
        229: sl_d1,
        500: sl_z2,
        591: sl_e1,
        833: sl_a3,
        119: sl_y1,
        401: sl_b1,
        56: sl_c1,
        230: sl_d1,
        501: sl_z2,
        592: sl_e1,
        834: sl_a3,
        120: sl_y1,
        402: sl_b1,
        57: sl_c1,
        231: sl_d1,
        502: sl_z2,
        593: sl_e1,
        835: sl_a3,
        121: sl_y1
    },
    2: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        607: sl_f1,
        557: sl_x1,
        863: sl_l1,
        885: sl_l1,
        122: sl_g1,
        129: sl_h1,
        83: sl_b3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        608: sl_f1,
        558: sl_x1,
        864: sl_l1,
        886: sl_l1,
        123: sl_g1,
        130: sl_h1,
        84: sl_b3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        609: sl_f1,
        559: sl_x1,
        865: sl_l1,
        887: sl_l1,
        124: sl_g1,
        131: sl_h1,
        85: sl_b3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        610: sl_f1,
        560: sl_x1,
        866: sl_l1,
        888: sl_l1,
        125: sl_g1,
        132: sl_h1,
        86: sl_b3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        611: sl_f1,
        561: sl_x1,
        867: sl_l1,
        889: sl_l1,
        126: sl_g1,
        133: sl_h1,
        87: sl_b3,
        371: sl_b1,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        612: sl_f1,
        562: sl_x1,
        868: sl_l1,
        890: sl_l1,
        127: sl_g1,
        134: sl_h1,
        88: sl_b3,
        372: sl_b1,
        27: sl_c1,
        201: sl_d1,
        144: sl_i1,
        188: sl_j1,
        613: sl_f1,
        563: sl_x1,
        869: sl_l1,
        891: sl_l1,
        128: sl_g1,
        135: sl_h1,
        89: sl_b3
    },
    6: {
        1861: sl_c3,
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        333: sl_d3,
        557: sl_e3,
        745: sl_v1,
        896: sl_w1,
        618: sl_f3,
        594: sl_g3,
        759: sl_h3,
        750: sl_i3,
        190: sl_j3,
        83: sl_y1,
        300: sl_k3,
        310: sl_l3,
        545: sl_m3,
        508: sl_n3,
        552: sl_o3,
        708: sl_p3,
        76: sl_q3,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        334: sl_d3,
        558: sl_e3,
        746: sl_v1,
        897: sl_w1,
        619: sl_f3,
        595: sl_g3,
        760: sl_h3,
        751: sl_i3,
        191: sl_j3,
        84: sl_y1,
        301: sl_k3,
        311: sl_l3,
        546: sl_m3,
        509: sl_n3,
        553: sl_o3,
        709: sl_p3,
        77: sl_q3,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        335: sl_d3,
        559: sl_e3,
        747: sl_v1,
        898: sl_w1,
        620: sl_f3,
        596: sl_g3,
        761: sl_h3,
        752: sl_i3,
        192: sl_j3,
        85: sl_y1,
        302: sl_k3,
        312: sl_l3,
        547: sl_m3,
        510: sl_n3,
        554: sl_o3,
        710: sl_p3,
        78: sl_q3,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        336: sl_d3,
        560: sl_e3,
        748: sl_v1,
        899: sl_w1,
        621: sl_f3,
        597: sl_g3,
        762: sl_h3,
        753: sl_i3,
        193: sl_j3,
        86: sl_y1,
        303: sl_k3,
        313: sl_l3,
        548: sl_m3,
        511: sl_n3,
        555: sl_o3,
        711: sl_p3,
        79: sl_q3,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        337: sl_d3,
        561: sl_e3,
        749: sl_v1,
        900: sl_w1,
        622: sl_f3,
        598: sl_g3,
        763: sl_h3,
        754: sl_i3,
        194: sl_j3,
        87: sl_y1,
        304: sl_k3,
        314: sl_l3,
        549: sl_m3,
        512: sl_n3,
        556: sl_o3,
        712: sl_p3,
        80: sl_q3
    },
    4: {
        366: sl_b1,
        21: sl_c1,
        195: sl_d1,
        138: sl_i1,
        182: sl_j1,
        896: sl_w1,
        557: sl_e1,
        836: sl_z1,
        909: sl_a2,
        914: sl_l1,
        920: sl_l1,
        83: sl_y1,
        903: sl_t1,
        607: sl_f1,
        367: sl_b1,
        22: sl_c1,
        196: sl_d1,
        139: sl_i1,
        183: sl_j1,
        897: sl_w1,
        558: sl_e1,
        837: sl_z1,
        910: sl_a2,
        915: sl_l1,
        921: sl_l1,
        84: sl_y1,
        904: sl_t1,
        608: sl_f1,
        368: sl_b1,
        23: sl_c1,
        197: sl_d1,
        140: sl_i1,
        184: sl_j1,
        898: sl_w1,
        559: sl_e1,
        838: sl_z1,
        911: sl_a2,
        916: sl_l1,
        922: sl_l1,
        85: sl_y1,
        905: sl_t1,
        609: sl_f1,
        369: sl_b1,
        24: sl_c1,
        198: sl_d1,
        141: sl_i1,
        185: sl_j1,
        899: sl_w1,
        560: sl_e1,
        839: sl_z1,
        912: sl_a2,
        917: sl_l1,
        923: sl_l1,
        86: sl_y1,
        906: sl_t1,
        610: sl_f1,
        370: sl_b1,
        25: sl_c1,
        199: sl_d1,
        142: sl_i1,
        186: sl_j1,
        900: sl_w1,
        561: sl_e1,
        840: sl_z1,
        913: sl_a2,
        918: sl_l1,
        924: sl_l1,
        87: sl_y1,
        907: sl_t1,
        611: sl_f1,
        26: sl_c1,
        200: sl_d1,
        143: sl_i1,
        187: sl_j1,
        371: sl_b1,
        562: sl_e1,
        919: sl_l1,
        925: sl_l1,
        901: sl_r3,
        908: sl_t1,
        88: sl_y1,
        362: sl_k1,
        17: sl_c1,
        176: sl_d1,
        358: sl_k1,
        13: sl_c1,
        172: sl_d1,
        363: sl_k1,
        18: sl_c1,
        177: sl_d1,
        359: sl_k1,
        14: sl_c1,
        173: sl_d1,
        364: sl_k1,
        19: sl_c1,
        178: sl_d1,
        360: sl_k1,
        15: sl_c1,
        174: sl_d1,
        365: sl_k1,
        20: sl_c1,
        179: sl_d1,
        361: sl_k1,
        16: sl_c1,
        175: sl_d1
    },
    8: {
        664: sl_b1,
        195: sl_d1,
        665: sl_b1,
        196: sl_d1,
        666: sl_b1,
        197: sl_d1,
        667: sl_b1,
        198: sl_d1
    }
};

let baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_o3,
        778: bo_a5,
        779: bo_b5,
        780: bo_c5,
        781: bo_d5,
        783: bo_e5,
        773: bo_f5,
        474: bo_g5,
        421: bo_h5,
        530: bo_i5,
        422: bo_j5,
        531: bo_k5,
        444: bo_l5,
        888: bo_m5,
        280: bo_n5,
        317: bo_o5,
        424: bo_p5,
        533: bo_q5,
        423: bo_r5,
        532: bo_s5,
        637: bo_t5,
        788: bo_u5,
        784: bo_v5,
        785: bo_w5,
        786: bo_x5,
        787: bo_y5,
        774: bo_v5,
        775: bo_w5,
        776: bo_x5,
        777: bo_y5,
        281: bo_z5,
        137: bo_a6,
        246: bo_b6,
        248: bo_c6,
        240: bo_d6,
        232: bo_e6,
        241: bo_f6,
        233: bo_g6,
        61: bo_h6,
        62: bo_i6,
        684: bo_j6,
        685: bo_k6,
        443: bo_h1,
        608: bo_i1,
        890: bo_l6,
        242: bo_m6,
        245: bo_n6,
        243: bo_o6,
        60: bo_p6,
        683: bo_q6,
        406: bo_r6,
        405: bo_s6,
        404: bo_t6,
        700: bo_u6,
        408: bo_v6,
        407: bo_w6,
        247: bo_x6,
        244: bo_y6,
        638: bo_z6,
        639: bo_a7,
        640: bo_b7,
        641: bo_c7,
        646: bo_d7,
        642: bo_e7,
        643: bo_f7,
        644: bo_g7,
        645: bo_h7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_p4,
        22: bo_q4,
        403: bo_g1,
        673: bo_i7,
        674: bo_j7,
        195: bo_m4,
        196: bo_o4,
        791: bo_k7,
        792: bo_l7,
        637: bo_t5,
        796: bo_u5,
        794: bo_m7,
        795: bo_n7,
        789: bo_m7,
        790: bo_n7,
        725: bo_o7,
        726: bo_p7,
        793: bo_o3,
        411: bo_w6,
        701: bo_l5,
        251: bo_q7,
        252: bo_r7,
        409: bo_j5,
        430: bo_k5,
        410: bo_r5,
        431: bo_s5,
        281: bo_z5,
        137: bo_a6,
        249: bo_b6,
        250: bo_c6,
        63: bo_h6,
        64: bo_i6,
        686: bo_j6,
        687: bo_k6,
        103: bo_f1,
        256: bo_d1,
        306: bo_e1,
        138: bo_s4,
        139: bo_t4,
        182: bo_u4,
        183: bo_v4,
        443: bo_h1,
        608: bo_i1,
        648: bo_s7,
        649: bo_t7
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_u7,
        196: bo_v7,
        197: bo_w7,
        673: bo_x7,
        674: bo_y7,
        675: bo_z7,
        610: bo_a8,
        443: bo_h1,
        608: bo_i1,
        806: bo_b8,
        893: bo_c8,
        707: bo_d8,
        708: bo_e8,
        709: bo_f8,
        889: bo_o3,
        904: bo_g8,
        253: bo_h8,
        688: bo_i8,
        65: bo_j8,
        751: bo_q3,
        21: bo_k8,
        22: bo_l8,
        23: bo_m8,
        743: bo_n8,
        744: bo_o8,
        745: bo_p8,
        615: bo_i3,
        350: bo_h8
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        746: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_q8,
        567: bo_r8,
        568: bo_s8,
        74: bo_t8,
        854: bo_u8,
        855: bo_v8,
        856: bo_w8,
        857: bo_u8,
        858: bo_v8,
        859: bo_w8,
        797: bo_x8,
        798: bo_y8,
        799: bo_z8,
        851: bo_a9,
        852: bo_b9,
        853: bo_c9,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        905: bo_g9,
        906: bo_h9,
        907: bo_i9,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        17: bo_p2,
        18: bo_q2,
        176: bo_s2,
        177: bo_t2,
        358: bo_v2,
        359: bo_w2,
        13: bo_y2,
        14: bo_z2,
        172: bo_b3,
        173: bo_c3,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        891: bo_l3,
        257: bo_d1,
        307: bo_e1,
        800: bo_j9,
        801: bo_k9,
        802: bo_l9
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_m9,
        196: bo_n9,
        197: bo_o9,
        198: bo_p9,
        199: bo_q9,
        200: bo_r9,
        201: bo_s9,
        202: bo_t9,
        138: bo_u9,
        139: bo_v9,
        140: bo_w9,
        141: bo_x9,
        142: bo_y9,
        143: bo_z9,
        144: bo_a10,
        145: bo_b10,
        182: bo_c10,
        183: bo_d10,
        184: bo_e10,
        185: bo_f10,
        186: bo_g10,
        187: bo_h10,
        188: bo_i10,
        189: bo_j10,
        21: bo_k10,
        22: bo_l10,
        23: bo_m10,
        24: bo_n10,
        25: bo_o10,
        26: bo_p10,
        27: bo_q10,
        28: bo_r10,
        673: bo_s10,
        674: bo_t10,
        675: bo_u10,
        676: bo_v10,
        677: bo_w10,
        678: bo_x10,
        679: bo_y10,
        680: bo_z10,
        860: bo_a11,
        861: bo_b11,
        862: bo_c11,
        863: bo_d11,
        864: bo_e11,
        865: bo_f11,
        866: bo_g11,
        867: bo_h11,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_i11,
        948: bo_j11,
        949: bo_k11
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_l11,
        615: bo_m11,
        413: bo_n11,
        414: bo_o11
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_l11,
        615: bo_p11,
        413: bo_n11,
        414: bo_q11,
        566: bo_r11,
        567: bo_s11,
        568: bo_t11,
        569: bo_u11,
        570: bo_v11,
        698: bo_w11,
        366: bo_x11,
        367: bo_y11,
        368: bo_z11,
        369: bo_a12,
        370: bo_b12,
        940: bo_c12,
        941: bo_d12,
        942: bo_e12,
        943: bo_f12,
        944: bo_g12
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_h12,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_i3,
        256: bo_d1,
        306: bo_e1,
        673: bo_x7,
        21: bo_k8,
        195: bo_u7,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_i12,
        534: bo_j12,
        540: bo_k12,
        343: bo_l12,
        345: bo_m12,
        260: bo_n12,
        261: bo_o12,
        83: bo_p12,
        84: bo_q12,
        803: bo_r12,
        868: bo_s12,
        869: bo_t12,
        870: bo_u12,
        805: bo_v12,
        892: bo_w12,
        346: bo_x12,
        419: bo_y12,
        528: bo_z12,
        420: bo_a13,
        529: bo_b13,
        707: bo_c13,
        708: bo_d13,
        706: bo_e13,
        804: bo_f13,
        474: bo_g13,
        614: bo_h13,
        609: bo_i13,
        416: bo_j13,
        732: bo_k13,
        525: bo_l13,
        850: bo_m13,
        473: bo_n13,
        442: bo_o13,
        729: bo_p13,
        538: bo_q13,
        542: bo_r13,
        730: bo_s13,
        471: bo_t13,
        635: bo_u13,
        714: bo_v13,
        624: bo_w13,
        625: bo_x13,
        715: bo_y13,
        650: bo_z13,
        651: bo_a14,
        652: bo_b14,
        653: bo_c14,
        654: bo_d14,
        655: bo_e14,
        634: bo_f14,
        626: bo_g14,
        733: bo_h14,
        734: bo_i14,
        258: bo_j14,
        259: bo_k14,
        66: bo_l14,
        67: bo_m14,
        81: bo_n14,
        68: bo_o14,
        689: bo_p14,
        690: bo_q14,
        699: bo_r14,
        691: bo_s14,
        723: bo_t14,
        633: bo_u14,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_v14,
        904: bo_w14,
        1: bo_r3,
        136: bo_x14,
        747: bo_q3,
        871: bo_o3,
        255: bo_y14,
        705: bo_z14,
        323: bo_a15,
        324: bo_b15,
        702: bo_c15,
        278: bo_d15,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        21: bo_f3,
        22: bo_f15,
        282: bo_g15,
        911: bo_l3,
        353: bo_h15,
        673: bo_g3,
        674: bo_i15,
        2: bo_j15,
        5: bo_k15,
        7: bo_l15,
        939: bo_m15,
        9: bo_n15,
        12: bo_o15,
        417: bo_p15,
        526: bo_q15,
        325: bo_r15,
        103: bo_f1,
        160: bo_s15,
        163: bo_t15,
        165: bo_u15,
        166: bo_v15,
        168: bo_w15,
        171: bo_x15,
        148: bo_y15,
        149: bo_z15,
        150: bo_a16,
        151: bo_b16,
        152: bo_c16,
        153: bo_d16,
        154: bo_e16,
        155: bo_f16,
        156: bo_g16,
        157: bo_h16,
        158: bo_i16,
        159: bo_j16,
        731: bo_i3,
        765: bo_k16,
        766: bo_l16,
        415: bo_m16,
        524: bo_n16,
        418: bo_o16,
        527: bo_p16,
        743: bo_q16,
        744: bo_r16,
        710: bo_p3,
        321: bo_s16,
        326: bo_t16,
        327: bo_u16,
        724: bo_v16,
        661: bo_w16,
        664: bo_x16,
        666: bo_y16,
        667: bo_z16,
        669: bo_a17,
        672: bo_b17,
        426: bo_m3,
        535: bo_n3,
        537: bo_c17,
        541: bo_d17,
        539: bo_e17,
        138: bo_e3,
        139: bo_f17,
        182: bo_h3,
        183: bo_g17,
        437: bo_h17,
        436: bo_i17,
        694: bo_j17,
        71: bo_k17,
        271: bo_c1,
        268: bo_l17,
        265: bo_m17,
        267: bo_n17,
        270: bo_o17,
        272: bo_p17,
        269: bo_q17,
        266: bo_r17,
        264: bo_s17,
        281: bo_z5,
        137: bo_a6,
        660: bo_j3,
        880: bo_t17,
        879: bo_u17,
        429: bo_v17,
        433: bo_w17,
        443: bo_h1,
        608: bo_i1,
        881: bo_x17,
        273: bo_y17,
        274: bo_z17,
        435: bo_a18,
        704: bo_b18,
        432: bo_c18,
        428: bo_d18,
        434: bo_e18,
        439: bo_f18,
        440: bo_g18,
        441: bo_h18,
        438: bo_i18,
        623: bo_j18,
        180: bo_k18,
        146: bo_l18,
        659: bo_m18,
        749: bo_n18,
        69: bo_o18,
        262: bo_p18,
        692: bo_q18,
        703: bo_r18,
        70: bo_s18,
        263: bo_t18,
        693: bo_u18,
        72: bo_v18,
        277: bo_w18,
        695: bo_x18,
        750: bo_y18,
        181: bo_z18,
        147: bo_a19,
        276: bo_b19,
        275: bo_c19,
        735: bo_d19,
        736: bo_e19,
        737: bo_f19,
        738: bo_g19,
        739: bo_h19,
        740: bo_i19,
        356: bo_j19,
        357: bo_k19,
        354: bo_l19,
        355: bo_m19,
        937: bo_n19,
        657: bo_o19,
        658: bo_p19,
        412: bo_q19
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_i12,
        534: bo_j12,
        540: bo_k12,
        343: bo_l12,
        345: bo_m12,
        260: bo_n12,
        261: bo_o12,
        83: bo_p12,
        84: bo_q12,
        803: bo_r12,
        868: bo_s12,
        869: bo_t12,
        870: bo_u12,
        346: bo_x12,
        419: bo_y12,
        528: bo_z12,
        420: bo_a13,
        529: bo_b13,
        707: bo_c13,
        708: bo_d13,
        706: bo_e13,
        538: bo_q13,
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        322: bo_v14,
        904: bo_w14,
        1: bo_r3,
        136: bo_x14,
        747: bo_q3,
        871: bo_o3,
        255: bo_y14,
        705: bo_z14,
        323: bo_a15,
        324: bo_b15,
        702: bo_c15,
        278: bo_d15,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        21: bo_f3,
        22: bo_f15,
        282: bo_g15,
        911: bo_l3,
        353: bo_h15,
        673: bo_g3,
        674: bo_i15,
        2: bo_j15,
        5: bo_k15,
        7: bo_l15,
        939: bo_m15,
        9: bo_n15,
        12: bo_o15,
        417: bo_p15,
        526: bo_q15,
        325: bo_r15,
        103: bo_f1,
        160: bo_s15,
        163: bo_t15,
        165: bo_u15,
        166: bo_v15,
        168: bo_w15,
        171: bo_x15,
        148: bo_y15,
        149: bo_z15,
        150: bo_a16,
        151: bo_b16,
        152: bo_c16,
        153: bo_d16,
        154: bo_e16,
        155: bo_f16,
        156: bo_g16,
        157: bo_h16,
        158: bo_i16,
        159: bo_j16,
        731: bo_i3,
        765: bo_k16,
        766: bo_l16,
        415: bo_m16,
        524: bo_n16,
        418: bo_o16,
        527: bo_p16,
        743: bo_q16,
        744: bo_r16,
        710: bo_p3,
        321: bo_r19,
        326: bo_t16,
        327: bo_u16,
        724: bo_v16,
        661: bo_w16,
        664: bo_x16,
        666: bo_y16,
        667: bo_z16,
        669: bo_a17,
        672: bo_b17,
        426: bo_m3,
        535: bo_n3,
        537: bo_c17,
        541: bo_d17,
        539: bo_e17,
        138: bo_e3,
        139: bo_f17,
        182: bo_h3,
        183: bo_g17,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        103: bo_f1,
        615: bo_i3,
        886: bo_k16,
        887: bo_l16,
        911: bo_l3,
        884: bo_s19,
        885: bo_t19,
        882: bo_u19,
        883: bo_v19,
        723: bo_t14,
        673: bo_g3,
        674: bo_i15,
        21: bo_f3,
        22: bo_f15,
        138: bo_e3,
        182: bo_h3,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_k8,
        22: bo_l8,
        23: bo_m8,
        279: bo_w19,
        610: bo_h12,
        256: bo_d1,
        306: bo_e1,
        195: bo_u7,
        196: bo_v7,
        197: bo_w7,
        673: bo_x7,
        674: bo_y7,
        675: bo_z7,
        350: bo_h8,
        103: bo_f1,
        415: bo_m16,
        524: bo_n16,
        743: bo_n8,
        744: bo_o8,
        745: bo_p8,
        710: bo_p3,
        403: bo_g1,
        426: bo_m3,
        535: bo_n3,
        706: bo_e13,
        343: bo_l12,
        346: bo_x12,
        83: bo_x19,
        84: bo_y19,
        85: bo_z19,
        344: bo_a20,
        347: bo_b20,
        765: bo_c20,
        766: bo_d20,
        767: bo_e20,
        138: bo_f20,
        139: bo_g20,
        140: bo_h20,
        182: bo_i20,
        183: bo_j20,
        184: bo_k20,
        751: bo_q3,
        911: bo_l3,
        889: bo_o3,
        637: bo_t5,
        615: bo_i3,
        412: bo_l20,
        634: bo_m20,
        626: bo_n20,
        611: bo_o20,
        443: bo_h1,
        608: bo_i1,
        904: bo_g8,
        449: bo_p20,
        446: bo_q20,
        451: bo_r20,
        711: bo_s20,
        712: bo_t20,
        713: bo_u20,
        450: bo_v20,
        447: bo_w20,
        448: bo_x20,
        662: bo_y20,
        663: bo_z20,
        665: bo_a21,
        668: bo_b21,
        670: bo_c21,
        671: bo_d21,
        3: bo_e21,
        4: bo_f21,
        6: bo_g21,
        8: bo_h21,
        10: bo_i21,
        11: bo_j21,
        161: bo_k21,
        162: bo_l21,
        164: bo_m21,
        167: bo_n21,
        169: bo_o21,
        170: bo_p21,
        707: bo_d8,
        708: bo_e8,
        709: bo_f8,
        946: bo_j13,
        947: bo_l13
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_q21,
        470: bo_r21,
        467: bo_s21,
        469: bo_t21,
        464: bo_u21,
        466: bo_v21,
        465: bo_w21,
        463: bo_x21,
        289: bo_y21,
        288: bo_z21,
        292: bo_a22,
        461: bo_b22,
        283: bo_c22,
        295: bo_d22,
        293: bo_e22,
        284: bo_f22,
        285: bo_g22,
        316: bo_h22,
        286: bo_i22,
        287: bo_j22,
        290: bo_k22,
        291: bo_l22,
        462: bo_m22,
        294: bo_n22
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_c1,
        950: bo_k11,
        955: bo_i11,
        951: bo_o22,
        952: bo_p22,
        953: bo_q22,
        954: bo_r22
    },
    33: {
        348: bo_s22,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_e15,
        673: bo_g3,
        674: bo_i15,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_t22,
        395: bo_u22,
        396: bo_v22,
        397: bo_w22,
        398: bo_x22,
        399: bo_y22,
        400: bo_z22,
        401: bo_a23,
        402: bo_b23,
        100: bo_c23,
        101: bo_d23,
        104: bo_e23,
        105: bo_f23,
        106: bo_g23,
        107: bo_h23,
        108: bo_i23,
        109: bo_j23,
        110: bo_k23,
        111: bo_l23,
        112: bo_m23,
        113: bo_n23,
        114: bo_o23,
        115: bo_p23,
        116: bo_q23,
        117: bo_r23,
        118: bo_s23,
        119: bo_t23,
        120: bo_u23,
        121: bo_v23,
        808: bo_w23,
        809: bo_x23,
        810: bo_y23,
        811: bo_z23,
        812: bo_a24,
        813: bo_b24,
        814: bo_c24,
        815: bo_d24,
        816: bo_e24,
        817: bo_f24,
        818: bo_g24,
        819: bo_h24,
        820: bo_i24,
        821: bo_j24,
        822: bo_k24,
        823: bo_l24,
        824: bo_m24,
        825: bo_n24,
        826: bo_o24,
        827: bo_p24,
        828: bo_q24,
        829: bo_r24,
        830: bo_s24,
        831: bo_t24,
        832: bo_u24,
        833: bo_v24,
        834: bo_w24,
        835: bo_x24,
        836: bo_y24,
        837: bo_z24,
        838: bo_a25,
        839: bo_b25,
        840: bo_c25,
        841: bo_d25,
        842: bo_e25,
        843: bo_f25,
        844: bo_g25,
        366: bo_h25,
        367: bo_i25,
        368: bo_j25,
        369: bo_k25,
        370: bo_l25,
        371: bo_m25,
        372: bo_n25,
        373: bo_o25,
        374: bo_p25,
        375: bo_q25,
        376: bo_r25,
        377: bo_s25,
        378: bo_t25,
        379: bo_u25,
        380: bo_v25,
        381: bo_w25,
        382: bo_x25,
        383: bo_y25,
        384: bo_z25,
        385: bo_a26,
        386: bo_b26,
        387: bo_c26,
        388: bo_d26,
        389: bo_e26,
        390: bo_f26,
        391: bo_g26,
        392: bo_h26,
        393: bo_i26,
        481: bo_j26,
        482: bo_k26,
        483: bo_l26,
        484: bo_m26,
        485: bo_n26,
        486: bo_o26,
        487: bo_p26,
        488: bo_q26,
        489: bo_r26,
        490: bo_s26,
        491: bo_t26,
        492: bo_u26,
        493: bo_v26,
        494: bo_w26,
        495: bo_x26,
        496: bo_y26,
        497: bo_z26,
        498: bo_a27,
        499: bo_b27,
        500: bo_c27,
        501: bo_d27,
        502: bo_e27,
        503: bo_f27,
        504: bo_g27,
        505: bo_h27,
        506: bo_i27,
        507: bo_j27,
        508: bo_k27,
        509: bo_l27,
        510: bo_m27,
        511: bo_n27,
        566: bo_o27,
        567: bo_p27,
        568: bo_q27,
        569: bo_r27,
        570: bo_s27,
        571: bo_t27,
        572: bo_u27,
        573: bo_v27,
        574: bo_w27,
        575: bo_x27,
        576: bo_y27,
        577: bo_z27,
        578: bo_a28,
        579: bo_b28,
        580: bo_c28,
        581: bo_d28,
        582: bo_e28,
        583: bo_f28,
        584: bo_g28,
        585: bo_h28,
        586: bo_i28,
        587: bo_j28,
        588: bo_k28,
        589: bo_l28,
        590: bo_m28,
        591: bo_n28,
        592: bo_o28,
        593: bo_p28,
        594: bo_q28,
        595: bo_r28,
        596: bo_s28,
        597: bo_t28,
        598: bo_u28,
        599: bo_v28,
        600: bo_w28,
        601: bo_x28,
        602: bo_y28,
        83: bo_z28,
        84: bo_a29,
        85: bo_b29,
        86: bo_c29,
        87: bo_d29,
        88: bo_e29,
        89: bo_f29,
        90: bo_g29,
        91: bo_h29,
        92: bo_i29,
        93: bo_j29,
        94: bo_k29,
        95: bo_l29,
        96: bo_m29,
        97: bo_n29,
        98: bo_o29,
        99: bo_p29,
        74: bo_b1,
        349: bo_c1,
        254: bo_q29,
        403: bo_g1,
        21: bo_r29,
        22: bo_s29,
        23: bo_t29,
        24: bo_u29,
        25: bo_v29,
        26: bo_w29,
        27: bo_x29,
        28: bo_y29,
        29: bo_z29,
        30: bo_a30,
        31: bo_b30,
        32: bo_c30,
        33: bo_d30,
        34: bo_e30,
        35: bo_f30,
        36: bo_g30,
        37: bo_h30,
        38: bo_i30,
        39: bo_j30,
        40: bo_k30,
        41: bo_l30,
        42: bo_m30,
        43: bo_n30,
        44: bo_o30,
        45: bo_p30,
        46: bo_q30,
        47: bo_r30,
        48: bo_s30,
        49: bo_t30,
        50: bo_u30,
        51: bo_v30,
        52: bo_w30,
        53: bo_x30,
        54: bo_y30,
        55: bo_z30,
        56: bo_a31,
        57: bo_b31,
        195: bo_c31,
        196: bo_d31,
        197: bo_e31,
        198: bo_f31,
        199: bo_g31,
        200: bo_h31,
        201: bo_i31,
        202: bo_j31,
        203: bo_k31,
        204: bo_l31,
        205: bo_m31,
        206: bo_n31,
        207: bo_o31,
        208: bo_p31,
        209: bo_q31,
        210: bo_r31,
        211: bo_s31,
        212: bo_t31,
        213: bo_u31,
        214: bo_v31,
        215: bo_w31,
        216: bo_x31,
        217: bo_y31,
        218: bo_z31,
        219: bo_a32,
        220: bo_b32,
        221: bo_c32,
        222: bo_d32,
        223: bo_e32,
        224: bo_f32,
        225: bo_g32,
        226: bo_h32,
        227: bo_i32,
        228: bo_j32,
        229: bo_k32,
        230: bo_l32,
        231: bo_m32,
        475: bo_n32,
        476: bo_o32,
        477: bo_p32,
        478: bo_q32,
        479: bo_r32,
        480: bo_s32,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_r29,
        22: bo_s29,
        23: bo_t29,
        24: bo_u29,
        25: bo_v29,
        26: bo_w29,
        27: bo_x29,
        195: bo_c31,
        196: bo_d31,
        197: bo_e31,
        198: bo_f31,
        199: bo_g31,
        200: bo_h31,
        201: bo_i31,
        352: bo_t32,
        102: bo_f1,
        403: bo_g1,
        138: bo_u32,
        139: bo_v32,
        140: bo_w32,
        141: bo_x32,
        142: bo_y32,
        143: bo_z32,
        144: bo_a33,
        182: bo_b33,
        183: bo_c33,
        184: bo_d33,
        185: bo_e33,
        186: bo_f33,
        187: bo_g33,
        188: bo_h33,
        566: bo_i33,
        567: bo_j33,
        568: bo_k33,
        569: bo_l33,
        570: bo_m33,
        571: bo_n33,
        572: bo_o33,
        366: bo_h25,
        367: bo_i25,
        368: bo_j25,
        369: bo_k25,
        370: bo_l25,
        371: bo_m25,
        372: bo_n25,
        122: bo_p33,
        123: bo_q33,
        124: bo_r33,
        125: bo_s33,
        126: bo_t33,
        127: bo_u33,
        128: bo_v33,
        129: bo_w33,
        130: bo_x33,
        131: bo_y33,
        132: bo_z33,
        133: bo_a34,
        134: bo_b34,
        135: bo_c34,
        872: bo_d34,
        873: bo_e34,
        874: bo_f34,
        875: bo_g34,
        876: bo_h34,
        877: bo_i34,
        878: bo_j34,
        616: bo_k34,
        617: bo_l34,
        618: bo_m34,
        619: bo_n34,
        620: bo_o34,
        621: bo_p34,
        622: bo_q34,
        894: bo_d34,
        895: bo_e34,
        896: bo_f34,
        897: bo_g34,
        898: bo_h34,
        899: bo_i34,
        900: bo_j34,
        443: bo_h1,
        608: bo_i1,
        83: bo_r34,
        84: bo_s34,
        85: bo_t34,
        86: bo_u34,
        87: bo_v34,
        88: bo_w34,
        89: bo_x34,
        257: bo_d1,
        307: bo_e1,
        752: bo_y34,
        753: bo_y34
    },
    6: {
        553: bo_z34,
        339: bo_a35,
        547: bo_b35,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_c35,
        142: bo_d35,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_e35,
        186: bo_f35,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        86: bo_g35,
        87: bo_h35,
        807: bo_i35,
        636: bo_j35,
        334: bo_k35,
        335: bo_l35,
        336: bo_m35,
        337: bo_n35,
        906: bo_h9,
        907: bo_i9,
        908: bo_o35,
        909: bo_p35,
        300: bo_q35,
        301: bo_r35,
        302: bo_s35,
        303: bo_t35,
        304: bo_u35,
        310: bo_v35,
        311: bo_w35,
        312: bo_x35,
        313: bo_y35,
        314: bo_z35,
        554: bo_a36,
        555: bo_b36,
        556: bo_c36,
        557: bo_d36,
        558: bo_e36,
        517: bo_f36,
        518: bo_g36,
        519: bo_h36,
        520: bo_i36,
        521: bo_j36,
        561: bo_k36,
        562: bo_l36,
        563: bo_m36,
        564: bo_n36,
        565: bo_o36,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_p36,
        25: bo_q36,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_r36,
        199: bo_s36,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_t36,
        445: bo_u36,
        754: bo_v36,
        755: bo_w36,
        756: bo_x36,
        757: bo_y36,
        758: bo_z36,
        452: bo_a37,
        453: bo_b37,
        454: bo_c37,
        566: bo_d37,
        567: bo_e37,
        568: bo_f37,
        569: bo_g37,
        570: bo_h37,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_i37,
        370: bo_j37,
        522: bo_k37,
        627: bo_l37,
        628: bo_m37,
        629: bo_n37,
        630: bo_o37,
        631: bo_p37,
        632: bo_q37,
        190: bo_r37,
        191: bo_s37,
        192: bo_t37,
        193: bo_u37,
        194: bo_v37,
        759: bo_w37,
        760: bo_x37,
        761: bo_y37,
        762: bo_z37,
        763: bo_a38,
        768: bo_b38,
        769: bo_c38,
        770: bo_d38,
        771: bo_e38,
        772: bo_f38,
        603: bo_g38,
        604: bo_h38,
        605: bo_i38,
        606: bo_j38,
        607: bo_k38,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_l38,
        341: bo_m38,
        427: bo_n38,
        536: bo_o38,
        905: bo_g9,
        320: bo_p38,
        514: bo_q38,
        516: bo_r38,
        305: bo_s38,
        315: bo_t38,
        523: bo_u38,
        299: bo_v38,
        309: bo_w38,
        697: bo_x38,
        298: bo_y38,
        308: bo_z38,
        515: bo_a39,
        549: bo_b39,
        548: bo_c39,
        443: bo_h1,
        608: bo_i1,
        550: bo_u36,
        551: bo_u36,
        455: bo_a37,
        456: bo_a37,
        457: bo_b37,
        458: bo_b37,
        459: bo_c37,
        460: bo_c37,
        512: bo_k37,
        513: bo_k37,
        901: bo_t36,
        902: bo_t36,
        340: bo_d39,
        328: bo_e39,
        329: bo_f39,
        342: bo_g39,
        330: bo_h39,
        331: bo_i39,
        722: bo_j39,
        560: bo_k39,
        543: bo_l39,
        544: bo_m39,
        545: bo_n39,
        546: bo_o39,
        332: bo_p39,
        559: bo_q39,
        296: bo_r39,
        297: bo_s39,
        717: bo_t39,
        718: bo_u39,
        719: bo_v39,
        720: bo_w39,
        721: bo_x39,
        552: bo_y39,
        76: bo_z39,
        77: bo_a40,
        78: bo_b40,
        79: bo_c40,
        80: bo_d40,
        647: bo_e40,
        741: bo_f40,
        82: bo_g40,
        338: bo_h40
    },
    17: {
        348: bo_s22,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_p36,
        25: bo_q36,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        198: bo_r36,
        199: bo_s36,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        141: bo_c35,
        142: bo_d35,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        185: bo_e35,
        186: bo_f35,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_i37,
        370: bo_j37,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        569: bo_i40,
        570: bo_j40,
        74: bo_t8,
        923: bo_u8,
        924: bo_v8,
        925: bo_w8,
        926: bo_k40,
        927: bo_l40,
        929: bo_u8,
        930: bo_v8,
        931: bo_w8,
        932: bo_k40,
        933: bo_l40,
        845: bo_x8,
        846: bo_y8,
        847: bo_z8,
        848: bo_m40,
        849: bo_n40,
        918: bo_a9,
        919: bo_b9,
        920: bo_c9,
        921: bo_o40,
        922: bo_p40,
        83: bo_d9,
        84: bo_e9,
        85: bo_f9,
        86: bo_g35,
        87: bo_h35,
        905: bo_g9,
        906: bo_h9,
        907: bo_i9,
        908: bo_o35,
        909: bo_p35,
        807: bo_i35,
        319: bo_q40,
        320: bo_p38,
        912: bo_j9,
        913: bo_k9,
        914: bo_l9,
        915: bo_r40,
        916: bo_s40,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        365: bo_t40,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        20: bo_u40,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        179: bo_v40,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        361: bo_w40,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        16: bo_x40,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        175: bo_y40,
        281: bo_z5,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_z40,
        620: bo_a41,
        891: bo_l3,
        26: bo_b41,
        200: bo_c41,
        143: bo_d41,
        187: bo_e41,
        371: bo_f41,
        571: bo_g41,
        928: bo_h41,
        934: bo_h41,
        88: bo_i41,
        910: bo_j41,
        917: bo_k41,
        936: bo_l41
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_m41,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_n41,
        613: bo_o41,
        443: bo_h1,
        608: bo_i1
    }
};

let outcomeConfig = {
    7: {
        426: (match, outcome) => `${match.homeTeam} победит с разницей ровно в ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`,
        535: (match, outcome) => `${match.awayTeam} победит с разницей ровно в ${outcome.condition} ${plural(outcome.condition, ['гол', 'гола', 'голов'])}`
    },
    6: {
        455: (match, outcome) => `Будет ли 15x15 в ${outcome.condition} гейме?`,
        456: (match, outcome) => `Будет ли 15x15 в ${outcome.condition} гейме?`,
        457: (match, outcome) => `Будет ли 30x30 в ${outcome.condition} гейме?`,
        458: (match, outcome) => `Будет ли 30x30 в ${outcome.condition} гейме?`,
        459: (match, outcome) => `Будет ли 40x40 в ${outcome.condition} гейме?`,
        460: (match, outcome) => `Будет ли 40x40 в ${outcome.condition} гейме?`
    }
};

let baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        727: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        728: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_y1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_x1
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_f4,
            2: fa_g4
        },
        888: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_r4,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_y4
        },
        784: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        785: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        786: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        787: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        774: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        775: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        776: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        777: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        685: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        406: {
            1: fa_h1,
            2: fa_i1
        },
        405: {
            1: fa_h1,
            2: fa_i1
        },
        404: {
            1: fa_h1,
            2: fa_i1
        },
        700: {
            1: fa_h5,
            2: fa_i5,
            3: fa_j5
        },
        408: {
            1: fa_h1,
            2: fa_i1
        },
        407: {
            1: fa_h1,
            2: fa_i1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_h1,
            2: fa_i1
        },
        639: {
            1: fa_h1,
            2: fa_i1
        },
        640: {
            1: fa_h1,
            2: fa_i1
        },
        641: {
            1: fa_h1,
            2: fa_i1
        },
        646: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        642: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        643: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        644: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        645: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_n5,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_o5
        },
        794: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        795: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        789: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        790: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        725: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        726: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_h1,
            2: fa_i1
        },
        701: {
            1: fa_f4,
            2: fa_g4,
            3: fa_r5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        687: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_h1,
            2: fa_i1
        },
        649: {
            1: fa_h1,
            2: fa_i1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_s5,
            2: fa_t5,
            3: fa_u5,
            4: fa_v5,
            5: fa_w5,
            6: fa_c5
        },
        893: {
            1: fa_x5,
            2: fa_y5,
            3: fa_z5,
            4: fa_a6,
            5: fa_b6,
            6: fa_c6
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        709: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        889: {
            1: fa_g6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_h6,
            6: fa_i6,
            7: fa_j6,
            8: fa_k6
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        855: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        856: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        857: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        858: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        859: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        797: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        798: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        799: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        851: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        852: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        853: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        801: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        802: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        677: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        678: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        679: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        680: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        860: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        861: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        862: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        863: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        864: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        865: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        866: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        867: {
            1: fa_q7,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_r7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_s7,
            2: fa_t7,
            3: fa_u7,
            4: fa_v7,
            5: fa_w7
        },
        949: {
            1: fa_x7,
            2: fa_y7,
            3: fa_z7,
            4: fa_a8,
            5: fa_b8,
            6: fa_c8,
            7: fa_d8,
            8: fa_e8,
            9: fa_f8,
            10: fa_g8,
            11: fa_h8,
            12: fa_i8,
            13: fa_t7,
            14: fa_u7,
            15: fa_j8,
            16: fa_k8,
            17: fa_l8,
            18: fa_m8,
            19: fa_n8,
            20: fa_o8,
            21: fa_p8,
            22: fa_q8,
            23: fa_r8,
            24: fa_s8,
            25: fa_t8,
            26: fa_u8,
            27: fa_w7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        }
    },
    42: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        413: {
            1: fa_h1,
            2: fa_i1
        },
        414: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_x1,
            2: fa_v8,
            3: fa_y1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        940: {
            1: fa_x1,
            2: fa_y1
        },
        941: {
            1: fa_x1,
            2: fa_y1
        },
        942: {
            1: fa_x1,
            2: fa_y1
        },
        943: {
            1: fa_x1,
            2: fa_y1
        },
        944: {
            1: fa_x1,
            2: fa_y1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        804: {
            1: fa_b9,
            2: fa_c9,
            3: fa_d9,
            4: fa_e9
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        614: {
            1: fa_h1,
            2: fa_i1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_f9,
            2: fa_g9,
            3: fa_h9,
            4: fa_i9
        },
        473: {
            1: fa_j9,
            2: fa_k9
        },
        442: {
            1: fa_j9,
            2: fa_k9
        },
        729: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        471: {
            1: fa_j9,
            2: fa_k9
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        624: {
            1: fa_h1,
            2: fa_i1
        },
        625: {
            1: fa_h1,
            2: fa_i1
        },
        715: {
            1: fa_n9,
            2: fa_o9,
            3: fa_p9
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_n9,
            2: fa_o9,
            3: fa_q9
        },
        734: {
            1: fa_n9,
            2: fa_o9,
            3: fa_q9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        690: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        699: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        691: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        723: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        633: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_r9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_s9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_t9,
            30: fa_u9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_v9,
            2: fa_w9,
            3: fa_x9
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_y9,
            2: fa_q9
        },
        526: {
            1: fa_y9,
            2: fa_q9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        661: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        664: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        666: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        667: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        669: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        672: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_c10,
            2: fa_d10,
            3: fa_e10,
            4: fa_f10
        },
        879: {
            1: fa_g10,
            2: fa_h10,
            3: fa_i10,
            4: fa_j10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10,
            4: fa_n10,
            5: fa_o10,
            6: fa_p10
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_q10,
            2: fa_r10,
            3: fa_s10
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_h1,
            2: fa_i1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        703: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_t10,
            12: fa_u10,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_v10,
            24: fa_w10
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        736: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        737: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        738: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        739: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        740: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_x10,
            2: fa_y10,
            3: fa_z10,
            4: fa_a11,
            5: fa_b11,
            6: fa_c11,
            7: fa_d11,
            8: fa_e11,
            9: fa_f11,
            10: fa_g11
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_x8
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_r9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_s9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_t9,
            30: fa_u9,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_v9,
            2: fa_w9,
            3: fa_x9
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_l9,
            2: fa_a2,
            3: fa_m9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_y9,
            2: fa_q9
        },
        526: {
            1: fa_y9,
            2: fa_q9
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        661: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        664: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        666: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        667: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        669: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        672: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        885: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_h11
        },
        882: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_b2
        },
        883: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_b2
        },
        723: {
            1: fa_h1,
            2: fa_a2,
            3: fa_i1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_y8,
            2: fa_z8,
            3: fa_a9
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_g6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_h6,
            6: fa_i6,
            7: fa_j6,
            8: fa_k6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_l6,
            2: fa_m6,
            3: fa_n6,
            4: fa_o6,
            5: fa_p6,
            6: fa_q6,
            7: fa_r6,
            8: fa_s6,
            9: fa_t6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_i11,
            2: fa_j11,
            3: fa_k11
        },
        712: {
            1: fa_l11,
            2: fa_m11,
            3: fa_n11
        },
        713: {
            1: fa_o11,
            2: fa_p11,
            3: fa_q11
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        663: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        665: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        668: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        670: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        671: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        708: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        709: {
            1: fa_d6,
            2: fa_e6,
            3: fa_f6
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_z9,
            2: fa_b10
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        950: {
            1: fa_x7,
            2: fa_y7,
            3: fa_z7,
            4: fa_a8,
            5: fa_b8,
            6: fa_t7,
            7: fa_u7,
            8: fa_j8,
            9: fa_k8,
            10: fa_l8,
            11: fa_m8,
            12: fa_n8,
            13: fa_w7
        },
        955: {
            1: fa_l1,
            2: fa_m1
        },
        951: {
            1: fa_r11,
            2: fa_s11
        },
        952: {
            1: fa_r11,
            2: fa_s11
        },
        953: {
            1: fa_r11,
            2: fa_s11
        },
        954: {
            1: fa_r11,
            2: fa_s11
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_x1,
            2: fa_y1
        },
        395: {
            1: fa_x1,
            2: fa_y1
        },
        396: {
            1: fa_x1,
            2: fa_y1
        },
        397: {
            1: fa_x1,
            2: fa_y1
        },
        398: {
            1: fa_x1,
            2: fa_y1
        },
        399: {
            1: fa_x1,
            2: fa_y1
        },
        400: {
            1: fa_x1,
            2: fa_y1
        },
        401: {
            1: fa_x1,
            2: fa_y1
        },
        402: {
            1: fa_x1,
            2: fa_y1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        809: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        810: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        811: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        812: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        813: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        814: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        815: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        816: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        817: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        818: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        819: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        820: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        821: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        822: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        823: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        824: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        825: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        826: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        827: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        828: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        829: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        830: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        831: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        832: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        833: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        834: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        835: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        836: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        837: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        838: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        839: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        840: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        841: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        842: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        843: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        844: {
            1: fa_t11,
            2: fa_u11,
            3: fa_v11,
            4: fa_w11,
            5: fa_x11,
            6: fa_y11
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        373: {
            1: fa_x1,
            2: fa_y1
        },
        374: {
            1: fa_x1,
            2: fa_y1
        },
        375: {
            1: fa_x1,
            2: fa_y1
        },
        376: {
            1: fa_x1,
            2: fa_y1
        },
        377: {
            1: fa_x1,
            2: fa_y1
        },
        378: {
            1: fa_x1,
            2: fa_y1
        },
        379: {
            1: fa_x1,
            2: fa_y1
        },
        380: {
            1: fa_x1,
            2: fa_y1
        },
        381: {
            1: fa_x1,
            2: fa_y1
        },
        382: {
            1: fa_x1,
            2: fa_y1
        },
        383: {
            1: fa_x1,
            2: fa_y1
        },
        384: {
            1: fa_x1,
            2: fa_y1
        },
        385: {
            1: fa_x1,
            2: fa_y1
        },
        386: {
            1: fa_x1,
            2: fa_y1
        },
        387: {
            1: fa_x1,
            2: fa_y1
        },
        388: {
            1: fa_x1,
            2: fa_y1
        },
        389: {
            1: fa_x1,
            2: fa_y1
        },
        390: {
            1: fa_x1,
            2: fa_y1
        },
        391: {
            1: fa_x1,
            2: fa_y1
        },
        392: {
            1: fa_x1,
            2: fa_y1
        },
        393: {
            1: fa_x1,
            2: fa_y1
        },
        481: {
            1: fa_h1,
            2: fa_i1
        },
        482: {
            1: fa_h1,
            2: fa_i1
        },
        483: {
            1: fa_h1,
            2: fa_i1
        },
        484: {
            1: fa_h1,
            2: fa_i1
        },
        485: {
            1: fa_h1,
            2: fa_i1
        },
        486: {
            1: fa_h1,
            2: fa_i1
        },
        487: {
            1: fa_h1,
            2: fa_i1
        },
        488: {
            1: fa_h1,
            2: fa_i1
        },
        489: {
            1: fa_h1,
            2: fa_i1
        },
        490: {
            1: fa_h1,
            2: fa_i1
        },
        491: {
            1: fa_h1,
            2: fa_i1
        },
        492: {
            1: fa_h1,
            2: fa_i1
        },
        493: {
            1: fa_h1,
            2: fa_i1
        },
        494: {
            1: fa_h1,
            2: fa_i1
        },
        495: {
            1: fa_h1,
            2: fa_i1
        },
        496: {
            1: fa_h1,
            2: fa_i1
        },
        497: {
            1: fa_h1,
            2: fa_i1
        },
        498: {
            1: fa_h1,
            2: fa_i1
        },
        499: {
            1: fa_h1,
            2: fa_i1
        },
        500: {
            1: fa_h1,
            2: fa_i1
        },
        501: {
            1: fa_h1,
            2: fa_i1
        },
        502: {
            1: fa_h1,
            2: fa_i1
        },
        503: {
            1: fa_h1,
            2: fa_i1
        },
        504: {
            1: fa_h1,
            2: fa_i1
        },
        505: {
            1: fa_h1,
            2: fa_i1
        },
        506: {
            1: fa_h1,
            2: fa_i1
        },
        507: {
            1: fa_h1,
            2: fa_i1
        },
        508: {
            1: fa_h1,
            2: fa_i1
        },
        509: {
            1: fa_h1,
            2: fa_i1
        },
        510: {
            1: fa_h1,
            2: fa_i1
        },
        511: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        573: {
            1: fa_h1,
            2: fa_i1
        },
        574: {
            1: fa_h1,
            2: fa_i1
        },
        575: {
            1: fa_h1,
            2: fa_i1
        },
        576: {
            1: fa_h1,
            2: fa_i1
        },
        577: {
            1: fa_h1,
            2: fa_i1
        },
        578: {
            1: fa_h1,
            2: fa_i1
        },
        579: {
            1: fa_h1,
            2: fa_i1
        },
        580: {
            1: fa_h1,
            2: fa_i1
        },
        581: {
            1: fa_h1,
            2: fa_i1
        },
        582: {
            1: fa_h1,
            2: fa_i1
        },
        583: {
            1: fa_h1,
            2: fa_i1
        },
        584: {
            1: fa_h1,
            2: fa_i1
        },
        585: {
            1: fa_h1,
            2: fa_i1
        },
        586: {
            1: fa_h1,
            2: fa_i1
        },
        587: {
            1: fa_h1,
            2: fa_i1
        },
        588: {
            1: fa_h1,
            2: fa_i1
        },
        589: {
            1: fa_h1,
            2: fa_i1
        },
        590: {
            1: fa_h1,
            2: fa_i1
        },
        591: {
            1: fa_h1,
            2: fa_i1
        },
        592: {
            1: fa_h1,
            2: fa_i1
        },
        593: {
            1: fa_h1,
            2: fa_i1
        },
        594: {
            1: fa_h1,
            2: fa_i1
        },
        595: {
            1: fa_h1,
            2: fa_i1
        },
        596: {
            1: fa_h1,
            2: fa_i1
        },
        597: {
            1: fa_h1,
            2: fa_i1
        },
        598: {
            1: fa_h1,
            2: fa_i1
        },
        599: {
            1: fa_h1,
            2: fa_i1
        },
        600: {
            1: fa_h1,
            2: fa_i1
        },
        601: {
            1: fa_h1,
            2: fa_i1
        },
        602: {
            1: fa_h1,
            2: fa_i1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_h1,
            2: fa_i1
        },
        476: {
            1: fa_h1,
            2: fa_i1
        },
        477: {
            1: fa_h1,
            2: fa_i1
        },
        478: {
            1: fa_h1,
            2: fa_i1
        },
        479: {
            1: fa_h1,
            2: fa_i1
        },
        480: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        572: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        372: {
            1: fa_x1,
            2: fa_y1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        873: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        874: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        875: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        876: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        877: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        878: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_z11
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        621: {
            1: fa_h1,
            2: fa_i1
        },
        622: {
            1: fa_h1,
            2: fa_i1
        },
        894: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        895: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        896: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        897: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        898: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        899: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        900: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12,
            4: fa_d12
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_l6,
            2: fa_n6,
            3: fa_r6,
            4: fa_t6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        908: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        909: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        903: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        445: {
            1: fa_h1,
            2: fa_i1
        },
        754: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        755: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        756: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        757: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        758: {
            1: fa_r9,
            2: fa_s9,
            3: fa_e3,
            4: fa_m12,
            5: fa_e7,
            6: fa_n12,
            7: fa_t9,
            8: fa_u9,
            9: fa_o12,
            10: fa_p12,
            11: fa_q12,
            12: fa_r12,
            13: fa_s12,
            14: fa_t12
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        522: {
            1: fa_h1,
            2: fa_i1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        760: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        761: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        762: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        763: {
            1: fa_u12,
            2: fa_v12,
            3: fa_w12,
            4: fa_x12,
            5: fa_y12,
            6: fa_s12,
            7: fa_u10,
            8: fa_z12,
            9: fa_a13,
            10: fa_b13,
            11: fa_c13,
            12: fa_d13,
            13: fa_n12,
            14: fa_w10
        },
        768: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        769: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        770: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        771: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        772: {
            1: fa_j6,
            2: fa_e13,
            3: fa_f13,
            4: fa_g13,
            5: fa_h13,
            6: fa_c2,
            7: fa_i13
        },
        603: {
            1: fa_h1,
            2: fa_i1
        },
        604: {
            1: fa_h1,
            2: fa_i1
        },
        605: {
            1: fa_h1,
            2: fa_i1
        },
        606: {
            1: fa_h1,
            2: fa_i1
        },
        607: {
            1: fa_h1,
            2: fa_i1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_h1,
            2: fa_i1
        },
        516: {
            1: fa_h1,
            2: fa_i1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_h1,
            2: fa_i1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_j13,
            2: fa_i1
        },
        551: {
            1: fa_h1,
            2: fa_k13
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_j13,
            2: fa_i1
        },
        513: {
            1: fa_h1,
            2: fa_k13
        },
        901: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        902: {
            1: fa_e12,
            2: fa_f12,
            3: fa_g12,
            4: fa_h12,
            5: fa_i12,
            6: fa_j12,
            7: fa_k12,
            8: fa_l12
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_z9,
            2: fa_a10,
            3: fa_b10
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_l1,
            2: fa_m1
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        718: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        719: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        720: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        721: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_h1,
            2: fa_i1
        },
        741: {
            1: fa_l13,
            2: fa_u7,
            3: fa_m13
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_x1,
            2: fa_y1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_x1,
            2: fa_y1
        },
        367: {
            1: fa_x1,
            2: fa_y1
        },
        368: {
            1: fa_x1,
            2: fa_y1
        },
        369: {
            1: fa_x1,
            2: fa_y1
        },
        370: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_h1,
            2: fa_i1
        },
        567: {
            1: fa_h1,
            2: fa_i1
        },
        568: {
            1: fa_h1,
            2: fa_i1
        },
        569: {
            1: fa_h1,
            2: fa_i1
        },
        570: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        924: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        925: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        926: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        927: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        929: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        930: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        931: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        932: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        933: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        845: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        846: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        847: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        848: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        849: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_y1
        },
        918: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        919: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        920: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        921: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        922: {
            1: fa_t1,
            2: fa_e7,
            3: fa_f7,
            4: fa_x1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        906: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        907: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        908: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        909: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        807: {
            1: fa_l6,
            2: fa_n6,
            3: fa_r6,
            4: fa_t6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        913: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        914: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        915: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        916: {
            1: fa_k7,
            2: fa_l7,
            3: fa_m7,
            4: fa_n7,
            5: fa_o7,
            6: fa_p7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_x1,
            2: fa_y1
        },
        363: {
            1: fa_x1,
            2: fa_y1
        },
        364: {
            1: fa_x1,
            2: fa_y1
        },
        365: {
            1: fa_x1,
            2: fa_y1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_x1,
            2: fa_y1
        },
        359: {
            1: fa_x1,
            2: fa_y1
        },
        360: {
            1: fa_x1,
            2: fa_y1
        },
        361: {
            1: fa_x1,
            2: fa_y1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_h1,
            2: fa_i1
        },
        617: {
            1: fa_h1,
            2: fa_i1
        },
        618: {
            1: fa_h1,
            2: fa_i1
        },
        619: {
            1: fa_h1,
            2: fa_i1
        },
        620: {
            1: fa_h1,
            2: fa_i1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_n13,
            2: fa_o13
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_h1,
            2: fa_i1
        },
        928: {
            1: fa_s3,
            2: fa_u6,
            3: fa_v6,
            4: fa_w6,
            5: fa_x6,
            6: fa_y6,
            7: fa_z6,
            8: fa_a7
        },
        934: {
            1: fa_s3,
            2: fa_b7,
            3: fa_c7,
            4: fa_d7,
            5: fa_a7
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_g7,
            2: fa_h7,
            3: fa_i7,
            4: fa_j7
        },
        917: {
            1: fa_k7,
            2: fa_l7,
            3: fa_p13,
            4: fa_n7,
            5: fa_o7,
            6: fa_q13
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_h6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        674: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        675: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        676: {
            1: fa_x1,
            2: fa_z1,
            3: fa_y1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_x1,
            2: fa_y1
        },
        615: {
            1: fa_h1,
            2: fa_i1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_t9,
            2: fa_u9,
            3: fa_o12,
            4: fa_p12,
            5: fa_q12,
            6: fa_r13,
            7: fa_r9,
            8: fa_s9,
            9: fa_e3,
            10: fa_m12,
            11: fa_e7,
            12: fa_s13
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};

let periodConfig = {
    2: {
        208: 'Матч закончился',
        207: 'Седьмая партия',
        206: 'Шестая партия',
        205: 'Пятая партия',
        200: 'Матч еще не начался',
        203: 'Третья партия',
        202: 'Вторая партия',
        201: 'Первая партия',
        204: 'Четвертая партия'
    },
    3: {
        304: 'Матч закончился',
        303: 'Третий сет',
        302: 'Второй сет',
        301: 'Первый сет',
        300: 'Матч еще не начался'
    },
    4: {
        406: 'Матч закончился',
        403: 'Третий сет',
        402: 'Второй сет',
        401: 'Первый сет',
        400: 'Матч еще не начался',
        407: 'Золотой сет',
        405: 'Пятый сет',
        404: 'Четвертый сет'
    },
    5: {
        510: 'Десятый раунд',
        509: 'Девятый раунд',
        508: 'Восьмой раунд',
        507: 'Седьмой раунд',
        506: 'Шестой раунд',
        505: 'Пятый раунд',
        513: 'Матч закончился',
        503: 'Третий раунд',
        500: 'Матч еще не начался',
        501: 'Первый раунд',
        502: 'Второй раунд',
        511: 'Одиннадцатый раунд',
        512: 'Двенадцатый раунд',
        504: 'Четвертый раунд'
    },
    6: {
        600: 'Матч еще не начался',
        601: 'Первый сет',
        602: 'Второй сет',
        603: 'Третий сет',
        604: 'Четвертый сет',
        605: 'Пятый сет',
        606: 'Матч закончился'
    },
    7: {
        701: 'Первый тайм',
        700: 'Матч еще не начался',
        703: 'Второй тайм',
        704: 'Основное время закончилось',
        705: 'Первое дополнительное время',
        702: 'Перерыв',
        707: 'Второе дополнительное время',
        708: 'Закончилось второе дополнительное время',
        709: 'Пенальти',
        710: 'Матч закончился',
        706: 'Закончилось первое дополнительное время'
    },
    8: {
        808: 'Пауза',
        807: 'Четвёртая четверть',
        806: 'Пауза',
        805: 'Третья четверть',
        804: 'Перерыв',
        809: 'Овертайм',
        802: 'Пауза',
        801: 'Первая четверть',
        800: 'Матч еще не начался',
        810: 'Матч закончился',
        803: 'Вторая четверть'
    },
    9: {
        903: 'Второй тайм',
        902: 'Перерыв',
        901: 'Первый тайм',
        900: 'Матч еще не начался',
        904: 'Матч закончился'
    },
    12: {
        1203: 'Второй тайм',
        1202: 'Перерыв',
        1201: 'Первый тайм',
        1200: 'Матч еще не начался',
        1204: 'Матч закончился'
    },
    18: {
        1808: 'Закончился овертайм',
        1807: 'Овертайм',
        1806: 'Основное время закончилось',
        1805: 'Третий период',
        1804: 'Второй перерыв',
        1809: 'Пенальти',
        1802: 'Первый перерыв',
        1801: 'Первый период',
        1800: 'Матч еще не начался',
        1810: 'Матч закончился',
        1803: 'Второй период'
    },
    19: {
        1904: 'Основное время закончилось',
        1903: 'Второй тайм',
        1902: 'Перерыв',
        1901: 'Первый тайм',
        1900: 'Матч еще не начался',
        1905: 'Матч закончился'
    },
    20: {
        2016: 'Восьмой огневой рубеж',
        2017: 'Матч закончился',
        2000: 'Матч еще не начался',
        2001: 'Первый круг',
        2002: 'Первый огневой рубеж',
        2003: 'Второй круг',
        2004: 'Второй огневой рубеж',
        2005: 'Третий круг',
        2006: 'Третий огневой рубеж',
        2007: 'Четвертый круг',
        2008: 'Четвертый огневой рубеж',
        2009: 'Пятый круг',
        2010: 'Пятый огневой рубеж',
        2011: 'Шестой круг',
        2012: 'Шестой огневой рубеж',
        2013: 'Седьмой круг',
        2014: 'Седьмой огневой рубеж',
        2015: 'Восьмой круг'
    },
    28: {
        2801: 'Основное время',
        2802: 'Матч закончился',
        2800: 'Матч еще не начался'
    },
    29: {
        2911: '6-ая партия',
        2912: 'Перерыв',
        2913: '7-ая партия',
        2914: 'Перерыв',
        2915: '8-ая партия',
        2916: 'Перерыв',
        2917: '9-ая партия',
        2918: 'Перерыв',
        2919: '10-ая партия',
        2920: 'Перерыв',
        2921: '11-ая партия',
        2964: 'Перерыв',
        2965: '33-ья партия',
        2966: 'Перерыв',
        2967: '34-ая партия',
        2968: 'Перерыв',
        2969: '35-ая партия',
        2970: 'Перерыв',
        2971: '36-ая партия',
        2972: 'Перерыв',
        2973: '37-ая партия',
        2974: 'Матч закончился',
        2943: '22-ая партия',
        2944: 'Перерыв',
        2945: '23-ья партия',
        2946: 'Перерыв',
        2947: '24-ая партия',
        2948: 'Перерыв',
        2949: '25-ая партия',
        2950: 'Перерыв',
        2951: '26-ая партия',
        2952: 'Перерыв',
        2953: '27-ая партия',
        2954: 'Перерыв',
        2955: '28-ая партия',
        2956: 'Перерыв',
        2957: '29-ая партия',
        2958: 'Перерыв',
        2959: '30-ая партия',
        2960: 'Перерыв',
        2961: '31-ая партия',
        2962: 'Перерыв',
        2963: '32-ая партия',
        2922: 'Перерыв',
        2923: '12-ая партия',
        2924: 'Перерыв',
        2925: '13-ая партия',
        2926: 'Перерыв',
        2927: '14-ая партия',
        2928: 'Перерыв',
        2929: '15-ая партия',
        2930: 'Перерыв',
        2931: '16-ая партия',
        2932: 'Перерыв',
        2933: '17-ая партия',
        2934: 'Перерыв',
        2935: '18-ая партия',
        2936: 'Перерыв',
        2937: '19-ая партия',
        2938: 'Перерыв',
        2939: '20-ая партия',
        2940: 'Перерыв',
        2941: '21-ая партия',
        2942: 'Перерыв',
        2900: 'Матч еще не начался',
        2901: '1-ая партия',
        2902: 'Перерыв',
        2903: '2-ая партия',
        2904: 'Перерыв',
        2905: '3-ья партия',
        2906: 'Перерыв',
        2907: '4-ая партия',
        2908: 'Перерыв',
        2909: '5-ая партия',
        2910: 'Перерыв'
    },
    30: {
        3008: 'Закончилось дополнительное время',
        3007: 'Овертайм',
        3006: 'Основное время закончилось',
        3005: 'Третий период',
        3004: 'Второй перерыв',
        3009: 'Буллиты',
        3002: 'Первый перерыв',
        3001: 'Первый период',
        3000: 'Матч еще не начался',
        3010: 'Матч закончился',
        3003: 'Второй период'
    },
    31: {
        3108: 'Пауза',
        3107: 'Четвёртая четверть',
        3106: 'Пауза',
        3105: 'Третья четверть',
        3104: 'Перерыв',
        3109: 'Овертайм',
        3102: 'Пауза',
        3101: 'Первая четверть',
        3100: 'Матч еще не начался',
        3110: 'Матч закончился',
        3103: 'Вторая четверть'
    },
    32: {
        3203: 'Третий сет',
        3202: 'Второй сет',
        3201: 'Первый сет',
        3200: 'Матч еще не начался',
        3204: 'Матч закончился'
    },
    34: {
        3400: 'Матч еще не начался',
        3401: 'Первый тайм',
        3402: 'Перерыв',
        3403: 'Второй тайм',
        3404: 'Основное время закончилось',
        3410: 'Матч закончился',
        3406: 'Закончилось первое дополнительное время',
        3407: 'Второе дополнительное время',
        3408: 'Закончилось второе дополнительное время',
        3409: 'Пенальти',
        3405: 'Первое дополнительное время'
    },
    35: {
        3500: 'Матч еще не начался',
        3501: 'Первый тайм',
        3502: 'Перерыв',
        3503: 'Второй тайм',
        3504: 'Матч закончился'
    },
    36: {
        3601: 'Первый период',
        3602: 'Первый перерыв',
        3603: 'Второй период',
        3604: 'Второй перерыв',
        3605: 'Третий период',
        3600: 'Матч еще не начался',
        3607: 'Овертайм',
        3608: 'Закончилось дополнительное время',
        3609: 'Буллиты',
        3610: 'Матч закончился',
        3606: 'Основное время закончилось'
    },
    37: {
        3701: 'Матч закончился',
        3700: 'Матч еще не начался'
    },
    38: {
        3801: 'Матч закончился',
        3800: 'Матч еще не начался'
    },
    39: {
        3901: 'Матч закончился',
        3900: 'Матч еще не начался',
        3902: 'Первый раунд',
        3903: 'Второй раунд',
        3904: 'Третий раунд',
        3905: 'Четвертый раунд',
        3906: 'Пятый раунд',
    },
    40: {
        4001: 'Матч закончился',
        4000: 'Матч еще не начался'
    },
    41: {
        4102: 'Первый перерыв',
        4106: 'Матч закончился',
        4105: 'Овертайм',
        4104: 'Второй перерыв',
        4103: 'Вторая половина',
        4101: 'Первая половина',
        4100: 'Матч еще не начался'
    },
    42: {
        4202: 'Вторая карта',
        4206: 'Матч закончился',
        4205: 'Пятая карта',
        4204: 'Четвертая карта',
        4203: 'Третья карта',
        4201: 'Первая карта',
        4200: 'Матч еще не начался'
    }
};

export function getGroupName(sportId, groupType) {
    if (groupConfig !== undefined &&
        groupConfig[sportId] !== undefined) {
        return groupConfig[sportId][groupType];
    }

    return undefined;
}

export function getSlotName(sportId, match, slot) {
    let func;

    if (slotConfig !== undefined &&
       slotConfig[sportId] !== undefined) {
        func = slotConfig[sportId][slot.type];
    }

    if (func === undefined) {
        return undefined; 
    }

    return func(match, slot);
}


export function getOutcomeName(sportId, outcome, match) {
    let func;

    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }

    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getRateName(sportId, outcome, factorType, match) {
    let func;

    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }

    if (func === undefined) {
        return undefined;
    }

    return func(match, outcome);
}

export function getMatchInfoText(matchInfoType) {
    switch(matchInfoType) {
        case 1:
            return "Матч не начался";
        case 2:
            return "Матч закончился";
        case 3:
            return "Перерыв";
        case 4:
            return "Основное время закончилось";
        case 5:
            return "Первое доп. время закончилось";
        case 6:
            return "Серия пенальти";
    }
    
    return "";
}

export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return  periodConfig[sportId][periodId];
    }

    return undefined;
}

export function getFoulsText() {
    return "Фолы";
}

export function getTimeoutText() {
    return "Таймаут";
}


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/localization/ru.js